// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bb-yellow: #f4d03f;
  --bb-yellow-dark: #d4b02f;
  --bb-black: #000000;
  --bb-black-80: rgba(0, 0, 0, 0.8);
  --bb-green: #1e7b34;
  --bb-green-dark: #145a25;
  --bg-dark: #0a0a0a;
  --green-primary: #1e7b34;
  --green-dark: #145a25;
  --yellow-accent: #f4d03f;
  --crystal-blue: #7dd3fc;
  --green-rgba-12: rgba(30, 123, 52, 0.12);
  --green-rgba-25: rgba(30, 123, 52, 0.25);
  --green-rgba-40: rgba(30, 123, 52, 0.4);
  --green-rgba-50: rgba(30, 123, 52, 0.5);
  --green-rgba-70: rgba(30, 123, 52, 0.7);
  --green-rgba-80: rgba(30, 123, 52, 0.8);
  --yellow-rgba-08: rgba(244, 208, 63, 0.08);
  --yellow-rgba-50: rgba(244, 208, 63, 0.5);
  --crystal-rgba-50: rgba(125, 211, 252, 0.5);
  --white-rgba-40: rgba(255, 255, 255, 0.4);
  --white-rgba-50: rgba(255, 255, 255, 0.5);
  --white-rgba-60: rgba(255, 255, 255, 0.6);
  --black-rgba-50: rgba(0, 0, 0, 0.5);
  --black-rgba-70: rgba(0, 0, 0, 0.7);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body,
#root {
  width: 100%;
  height: 100%;
  height: 100dvh; /* Dynamic viewport height for mobile */
  min-height: -webkit-fill-available;
  overflow: hidden;
  background: var(--bb-black);
}

.landing-container {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%) translateZ(0);
  width: 100%;
  max-width: 430px;
  height: 100%;
  height: 100dvh;
  min-height: -webkit-fill-available;
  background: url('/images/road-texture.webp') center center / cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  contain: strict;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.8);
  position: relative;
  isolation: isolate;
  will-change: transform;
  backface-visibility: hidden;
}

.landing-about-link {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 100;
  font-size: 12px;
  color: var(--bb-yellow, #f4d03f);
  text-decoration: none;
  opacity: 0.9;
}
.landing-about-link:hover {
  text-decoration: underline;
  opacity: 1;
}

.landing-container::before {
  display: none;
}

.smoke-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  contain: strict;
}
.smoke {
  position: absolute;
  width: 200px;
  height: 200px;
  background: radial-gradient(ellipse at center, var(--green-rgba-12) 0%, transparent 70%);
  border-radius: 50%;
  filter: blur(40px);
  animation: smoke-rise 20s ease-in-out infinite;
  will-change: transform;
  contain: layout style paint;
}
.smoke:nth-child(1) {
  left: 5%;
}
.smoke:nth-child(2) {
  left: 20%;
  animation-delay: 4s;
  width: 250px;
  height: 250px;
}
.smoke:nth-child(3) {
  left: 35%;
  animation-delay: 8s;
}
.smoke:nth-child(4) {
  left: 50%;
  animation-delay: 2s;
  width: 180px;
  height: 180px;
}
.smoke:nth-child(5) {
  left: 65%;
  animation-delay: 6s;
}
.smoke:nth-child(6) {
  left: 80%;
  animation-delay: 10s;
  width: 220px;
  height: 220px;
}

.toxic-smoke {
  position: absolute;
  width: 300px;
  height: 300px;
  background: radial-gradient(ellipse at center, var(--yellow-rgba-08) 0%, transparent 70%);
  border-radius: 50%;
  filter: blur(50px);
  animation: toxic-drift 30s ease-in-out infinite;
  will-change: transform;
  contain: layout style paint;
}
.toxic-smoke:nth-child(1) {
  left: 10%;
}
.toxic-smoke:nth-child(2) {
  left: 70%;
  animation-delay: 15s;
}

.crystals {
  position: absolute;
  inset: 0;
  pointer-events: none;
  contain: strict;
  overflow: hidden;
  z-index: 1;
}

.meth-crystal {
  position: absolute;
  top: -60px;
  object-fit: contain;
  animation: crystal-fall linear infinite;
  will-change: transform;
  contain: layout style paint;
  opacity: 0.85;
}

.meth-crystal::before {
  content: '';
  position: absolute;
  width: 60%;
  height: 60%;
  top: 20%;
  left: 20%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, transparent 100%);
  clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
}

@keyframes crystal-fall {
  0% {
    transform: translateY(0) translateX(0) rotate(0deg) translateZ(0);
    opacity: 0.85;
  }
  25% {
    transform: translateY(25vh) translateX(5px) rotate(90deg) translateZ(0);
    opacity: 0.8;
  }
  50% {
    transform: translateY(50vh) translateX(-5px) rotate(180deg) translateZ(0);
    opacity: 0.75;
  }
  75% {
    transform: translateY(75vh) translateX(8px) rotate(270deg) translateZ(0);
    opacity: 0.6;
  }
  100% {
    transform: translateY(100vh) translateX(-8px) rotate(360deg) translateZ(0);
    opacity: 0;
  }
}

/* Falling pants container - behind laptop, same as crystals/ice */
.falling-pants-container {
  position: absolute;
  inset: 0;
  pointer-events: none;
  contain: strict;
  overflow: hidden;
  z-index: 1;
}

.falling-pants {
  position: absolute;
  top: -120px;
  object-fit: contain;
  animation: pants-fall linear infinite;
  will-change: transform;
  contain: layout style paint;
  opacity: 0.9;
  filter: drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.3));
}

@keyframes pants-fall {
  0% {
    transform: translateY(0) translateX(0) rotate(var(--start-rotation, 0deg)) translateZ(0);
    opacity: 0;
  }
  5% {
    opacity: 0.9;
  }
  15% {
    transform: translateY(15vh) translateX(calc(var(--sway-amount, 30px) * -1))
      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.15)) translateZ(0);
  }
  30% {
    transform: translateY(30vh) translateX(var(--sway-amount, 30px))
      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.3)) translateZ(0);
  }
  45% {
    transform: translateY(45vh) translateX(calc(var(--sway-amount, 30px) * -0.8))
      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.45)) translateZ(0);
  }
  60% {
    transform: translateY(60vh) translateX(calc(var(--sway-amount, 30px) * 0.6))
      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.6)) translateZ(0);
  }
  75% {
    transform: translateY(75vh) translateX(calc(var(--sway-amount, 30px) * -0.4))
      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.75)) translateZ(0);
    opacity: 0.7;
  }
  90% {
    opacity: 0.4;
  }
  100% {
    transform: translateY(110vh) translateX(calc(var(--sway-amount, 30px) * 0.2))
      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg))) translateZ(0);
    opacity: 0;
  }
}

.hazmat-stripe {
  position: absolute;
  left: 0;
  right: 0;
  height: 45px;
  z-index: 10;
  background: url('/images/warning-tape-divider.webp') center top / 100% auto no-repeat;
}

.hazmat-stripe.top {
  top: 0;
  background-position: center 25%;
}

.hazmat-stripe.bottom {
  bottom: 0;
  background-position: center 55%;
}

@keyframes text-scroll {
  0% {
    transform: translateX(100%) translateZ(0);
  }
  100% {
    transform: translateX(-100%) translateZ(0);
  }
}

.title-container {
  position: relative;
  z-index: 5;
  margin-bottom: 22px;
  animation: fade-in 0.8s ease-out forwards;
  contain: layout style paint;
  transform: translateZ(0);
}
.periodic-elements {
  display: grid;
  grid-template-columns: repeat(2, minmax(140px, 1fr));
  gap: 10px;
  justify-content: center;
  contain: layout style;
  width: 100%;
  max-width: 320px;
}
.element-tile {
  --tile-accent: #ff9800;
  --tile-glow: rgba(255, 152, 0, 0.35);
  background: linear-gradient(145deg, rgba(20, 25, 35, 0.96) 0%, rgba(10, 12, 18, 0.98) 100%);
  border: 2px solid color-mix(in srgb, var(--tile-accent) 55%, transparent);
  border-radius: 14px;
  padding: 12px 10px 10px;
  width: 100%;
  height: 88px;
  text-align: center;
  position: relative;
  box-shadow:
    0 16px 45px rgba(0, 0, 0, 0.7),
    0 0 35px var(--tile-glow),
    inset 0 1px 2px rgba(255, 255, 255, 0.06);
  contain: layout style paint;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition:
    transform 0.35s ease,
    box-shadow 0.35s ease;
}
.element-tile::before {
  content: attr(data-number);
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 10px;
  color: color-mix(in srgb, var(--tile-accent) 80%, #ffffff);
  font-family: 'Bebas Neue', sans-serif;
  text-shadow: 0 0 18px var(--tile-glow);
}
.element-tile::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    color-mix(in srgb, var(--tile-accent) 65%, #ffffff),
    transparent
  );
  opacity: 0.5;
}
.element-tile:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow:
    0 24px 65px var(--tile-glow),
    0 0 70px color-mix(in srgb, var(--tile-accent) 45%, transparent);
}
.element-tile:nth-child(1) {
  --tile-accent: #ff9800;
  --tile-glow: rgba(255, 152, 0, 0.35);
}
.element-tile:nth-child(2) {
  --tile-accent: #00e5ff;
  --tile-glow: rgba(0, 229, 255, 0.35);
}
.element-tile:nth-child(3) {
  --tile-accent: #e040fb;
  --tile-glow: rgba(224, 64, 251, 0.35);
}
.element-tile:nth-child(4) {
  --tile-accent: #22c55e;
  --tile-glow: rgba(34, 197, 94, 0.35);
}
.element-symbol {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 34px;
  letter-spacing: 1px;
  line-height: 1;
  font-weight: 800;
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    var(--tile-accent) 60%,
    color-mix(in srgb, var(--tile-accent) 80%, #000000) 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 0 14px var(--tile-glow));
}
.element-name {
  font-size: 9px;
  color: color-mix(in srgb, var(--tile-accent) 85%, #ffffff);
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 1;
  margin-top: 6px;
  font-weight: 700;
  text-shadow: 0 0 12px var(--tile-glow);
}

/* Dell Latitude D630 Laptop - Breaking Bad Style */
.lab-monitor {
  width: 92%;
  max-width: 380px;
  animation: video-appear 0.6s ease-out 0.3s forwards;
  opacity: 0;
  contain: layout style paint;
  transform: translateZ(0);
  margin: 0 auto;
}

.lab-monitor.dell-laptop {
  perspective: 900px;
  perspective-origin: 50% 28%;
  position: relative;
  z-index: 20;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-10vh) translateZ(40px) rotateY(-12deg) rotateX(6deg) scale(1.02);
  transform-style: preserve-3d;
  filter: drop-shadow(2px 4px 4px rgba(0, 0, 0, 0.6)) drop-shadow(8px 12px 16px rgba(0, 0, 0, 0.45))
    drop-shadow(20px 32px 40px rgba(0, 0, 0, 0.3)) drop-shadow(40px 56px 72px rgba(0, 0, 0, 0.2));
}

/* Laptop Lid (Screen portion) - folds DOWN onto keyboard */
.laptop-lid {
  transform-origin: bottom center;
  transform-style: preserve-3d;
  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  z-index: 10;
  width: 100%;
}

.laptop-lid.lid-dragging {
  transition: none;
  z-index: 100;
}

/* Open state - screen standing up, depth */
.dell-laptop.open .laptop-lid {
  transform: rotateX(-5deg) translateZ(2px);
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.5),
    0 8px 20px rgba(0, 0, 0, 0.35),
    0 18px 40px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

/* Closed state - lid folds forward 180deg to lay flat on keyboard */
.dell-laptop.closed .laptop-lid {
  transform: rotateX(-175deg);
  z-index: 100;
}

/* The bezel (front of screen) - swipe down to close when open */
.laptop-bezel {
  backface-visibility: hidden;
}

.dell-laptop.open .laptop-bezel {
  cursor: grab;
  touch-action: none;
}

.dell-laptop.open .laptop-bezel:active {
  cursor: grabbing;
}

/* Back of the lid - visible when closed, metallic 3D */
.closed-lid-cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 8px;
  overflow: hidden;
  background: linear-gradient(
    168deg,
    #b0b0b0 0%,
    #9a9a9a 20%,
    #848484 45%,
    #727272 70%,
    #626262 100%
  );
  border-radius: 12px 12px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    inset 4px 4px 10px rgba(255, 255, 255, 0.4),
    inset -3px -3px 8px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
  border: 1px solid #b8b8b8;
  border-top-color: #d0d0d0;
  border-left-color: #c0c0c0;
  border-right-color: #a0a0a0;
  border-bottom: none;
  transform: rotateX(180deg);
  backface-visibility: hidden;
  z-index: 200;
  cursor: grab;
  touch-action: none;
  user-select: none;
  pointer-events: auto !important;
}

.closed-lid-cover:active {
  cursor: grabbing;
}

.closed-lid-logo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 48px;
  width: auto;
  object-fit: contain;
  opacity: 0.7;
}

/* Lid edge (hinge area) - recessed 3D */
.lid-edge {
  height: 8px;
  background: linear-gradient(180deg, #3a3a3a 0%, #2e2e2e 35%, #242424 70%, #1c1c1c 100%);
  border-radius: 0 0 3px 3px;
  margin-top: -1px;
  box-shadow:
    inset 0 3px 6px rgba(0, 0, 0, 0.65),
    inset 0 1px 0 rgba(0, 0, 0, 0.4),
    0 1px 0 rgba(255, 255, 255, 0.04);
  border: 1px solid #2a2a2a;
  border-top: none;
}

/* Silver/gray bezel - 3D chamfered look */
.laptop-bezel {
  background: linear-gradient(
    168deg,
    #585858 0%,
    #484848 25%,
    #3c3c3c 55%,
    #323232 85%,
    #282828 100%
  );
  border-radius: 12px 12px 0 0;
  padding: 8px 8px 6px;
  box-shadow:
    0 -8px 20px rgba(0, 0, 0, 0.55),
    inset 3px 3px 6px rgba(255, 255, 255, 0.15),
    inset -2px -2px 4px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.12);
  backface-visibility: hidden;
  border: 1px solid #4a4a4a;
  border-top-color: #6a6a6a;
  border-left-color: #545454;
  border-right-color: #3a3a3a;
  border-bottom: none;
}

/* Back of lid (visible when closed) - silver back with Dell logo */
.laptop-lid::after {
  content: 'DELL';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 8px;
  background: linear-gradient(180deg, #7a7a7a 0%, #6a6a6a 50%, #5a5a5a 100%);
  border-radius: 12px 12px 0 0;
  transform: rotateX(180deg);
  transform-origin: bottom center;
  backface-visibility: hidden;
  z-index: 10;
  border: 1px solid #888;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Arial Black', Arial, sans-serif;
  font-size: 14px;
  font-weight: 900;
  color: #444;
  letter-spacing: 4px;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);
  opacity: 0;
  transition: opacity 0.4s ease 0.4s;
}

.bezel-top {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 0 4px;
  position: relative;
  min-height: 18px;
  z-index: 30;
  cursor: grab;
  touch-action: none;
  user-select: none;
}

.bezel-top:active {
  cursor: grabbing;
}

/* Sticker bomb - hand-placed feel, contained, no overlap */
.closed-lid-sticker-img {
  position: absolute;
  height: auto;
  object-fit: contain;
  pointer-events: none;
  border: none;
  outline: none;
  transform-origin: center center;
}

.closed-lid-sticker-1 {
  top: 9%;
  left: 11%;
  width: 22%;
  max-width: 72px;
  z-index: 214;
  transform: translate(1%, -2%) rotate(-27deg);
}

.closed-lid-sticker-2 {
  top: 6%;
  right: 13%;
  width: 10%;
  max-width: 34px;
  z-index: 211;
  transform: translate(-1%, 1%) rotate(4deg);
}

.closed-lid-sticker-3 {
  bottom: 28%;
  right: 19%;
  width: 12%;
  max-width: 40px;
  z-index: 213;
  transform: translate(-1%, 2%) rotate(-21deg);
}

.closed-lid-sticker-4 {
  top: 23%;
  right: 11%;
  width: 15%;
  max-width: 48px;
  z-index: 216;
  transform: translate(0, -1%) rotate(-16deg);
}

.closed-lid-sticker-5 {
  top: 51%;
  left: 31%;
  width: 9%;
  max-width: 30px;
  z-index: 210;
  transform: translate(-2%, 1%) rotate(24deg);
}

.closed-lid-sticker-6 {
  top: 28%;
  right: 32%;
  width: 15%;
  max-width: 50px;
  z-index: 212;
  transform: translate(-2%, -1%) rotate(-11deg);
}

.closed-lid-sticker-7 {
  bottom: 11%;
  left: 13%;
  width: 14%;
  max-width: 46px;
  z-index: 215;
  transform: translate(-1%, 0) rotate(-8deg);
}

.closed-lid-sticker-8 {
  bottom: 7%;
  right: 15%;
  width: 13%;
  max-width: 42px;
  z-index: 211;
  transform: translate(2%, calc(-1% - 12px)) rotate(19deg);
}

.webcam-dot {
  width: 6px;
  height: 6px;
  background: radial-gradient(circle, #1a1a1a 40%, #0a0a0a 100%);
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow:
    inset 0 0 2px rgba(0, 0, 0, 0.8),
    0 0 0 1.5px rgba(80, 80, 80, 0.5);
}

.dell-logo {
  height: 24px;
  width: auto;
  object-fit: contain;
  opacity: 0.85;
}

/* Inner screen - recessed glass 3D */
.laptop-screen {
  position: relative;
  background: #080808;
  border-radius: 4px;
  overflow: hidden;
  border: 2px solid #1a1a1a;
  border-top-color: #2a2a2a;
  border-left-color: #242424;
  border-right-color: #0e0e0e;
  border-bottom-color: #0c0c0c;
  transition: opacity 0.3s ease;
  box-shadow:
    inset 0 0 28px rgba(0, 0, 0, 0.95),
    inset 0 3px 8px rgba(0, 0, 0, 0.6),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.dell-laptop.closed .laptop-screen {
  opacity: 0;
}

.screen-header.win95-titlebar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 18px;
  padding: 0 4px;
  background: linear-gradient(90deg, #000080 0%, #1084d0 100%);
  border: none;
  border-bottom: 1px solid #000080;
}

.screen-header.win95-titlebar .win95-title {
  color: #fff;
  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;
  font-size: 11px;
  font-weight: bold;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.3);
}

.win95-btn-minimize,
.win95-btn-maximize,
.win95-btn-close {
  width: 14px;
  height: 12px;
  background: #c0c0c0;
  border: 1px outset #dfdfdf;
  font-size: 10px;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #000;
  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;
}

.win95-btn-minimize:active,
.win95-btn-maximize:active,
.win95-btn-close:active {
  border-style: inset;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.video-wrapper {
  position: relative;
  overflow: hidden;
  contain: layout style paint;
  transform: translateZ(0);
  pointer-events: none;
}

.video {
  width: 100%;
  display: block;
  background: #000;
  object-fit: cover;
  transform: translateZ(0);
  will-change: auto;
  pointer-events: none;
}

.video-overlay {
  display: none;
}

.video-scanline {
  display: none;
}

.video-corner-logo {
  position: absolute;
  bottom: 6px;
  right: 6px;
  z-index: 10;
  pointer-events: none;
}

.video-corner-logo-img {
  height: 24px;
  width: auto;
  max-width: 72px;
  object-fit: contain;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.5));
}

/* Windows balloon notification - click to open password dialog */
.win-balloon-notification {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 60px));
  z-index: 9999;
  pointer-events: auto !important;
  isolation: isolate;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  min-width: 200px;
  max-width: 280px;
  background: linear-gradient(180deg, #fff 0%, #f5f5f0 100%);
  border: 1px solid #999;
  border-radius: 4px;
  box-shadow:
    2px 2px 8px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  cursor: pointer;
  text-align: left;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  animation: balloon-slide-in 0.3s ease-out;
}

.win-balloon-notification::before {
  content: '';
  position: absolute;
  bottom: -8px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #999;
}

.win-balloon-notification::after {
  content: '';
  position: absolute;
  bottom: -6px;
  right: 21px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #f5f5f0;
}

.win-balloon-notification:hover {
  background: linear-gradient(180deg, #fff 0%, #fffff0 100%);
}

.win-balloon-icon {
  font-size: 24px;
  flex-shrink: 0;
  line-height: 1;
}

.win-balloon-content {
  flex: 1;
  min-width: 0;
}

.win-balloon-title {
  font-size: 11px;
  font-weight: 700;
  color: #003399;
  margin-bottom: 2px;
}

.win-balloon-text {
  font-size: 11px;
  color: #333;
  line-height: 1.3;
}

.win-balloon-close {
  font-size: 14px;
  color: #666;
  font-weight: bold;
  line-height: 1;
  padding: 0 2px;
  margin: -4px -4px 0 0;
}

.win-balloon-close:hover {
  color: #c00;
}

@keyframes balloon-slide-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Windows XP Taskbar */
.winxp-taskbar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 28px;
  background: linear-gradient(
    180deg,
    #3168d5 0%,
    #1842a3 3%,
    #2b5cd7 5%,
    #1d4fbf 90%,
    #1941a3 100%
  );
  display: flex;
  align-items: center;
  padding: 0 2px;
  z-index: 100;
  border-top: 1px solid #0c3c8c;
  font-family: 'Segoe UI', Tahoma, sans-serif;
}

.winxp-start-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  padding: 0 10px 0 6px;
  background: linear-gradient(180deg, #3b9c3b 0%, #2d8c2d 50%, #1e7b1e 100%);
  border: none;
  border-radius: 0 8px 8px 0;
  color: #fff;
  font-weight: 700;
  font-size: 11px;
  font-style: italic;
  cursor: pointer;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.3),
    1px 1px 2px rgba(0, 0, 0, 0.3);
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
}

.winxp-start-btn:hover {
  background: linear-gradient(180deg, #4bac4b 0%, #3d9c3d 50%, #2e8b2e 100%);
}

.winxp-start-btn:active {
  background: linear-gradient(180deg, #1e7b1e 0%, #2d8c2d 50%, #3b9c3b 100%);
}

.winxp-start-logo {
  font-size: 14px;
  font-style: normal;
}

.winxp-start-logo-img {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.winxp-start-text {
  letter-spacing: 0.5px;
}

.winxp-quicklaunch {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 6px;
  padding-left: 6px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.winxp-ql-icon {
  font-size: 12px;
  padding: 2px 3px;
  cursor: pointer;
  border-radius: 2px;
}

.winxp-ql-icon:hover {
  background: rgba(255, 255, 255, 0.15);
}

.winxp-tasks {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 6px;
  padding-left: 6px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.winxp-task {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 20px;
  padding: 0 8px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  color: #fff;
  font-size: 10px;
  cursor: pointer;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.winxp-task.active {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.1) 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.winxp-task-icon {
  font-size: 11px;
}

.winxp-task-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.winxp-systray {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  padding: 0 6px;
  height: 100%;
  background: linear-gradient(180deg, #0f8df5 0%, #0978d4 50%, #0560b8 100%);
  border-left: 1px solid rgba(0, 0, 0, 0.2);
}

.winxp-tray-icon {
  font-size: 11px;
  cursor: pointer;
}

.winxp-clock {
  font-size: 10px;
  color: #fff;
  padding-left: 4px;
  font-weight: 500;
}

/* Windows 95 Style Login Dialog - Compact */
.win95-login-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -110%);
  width: 220px;
  max-width: 220px;
  background: #c0c0c0;
  border: 2px outset #dfdfdf;
  box-shadow:
    inset -1px -1px 0 #808080,
    inset 1px 1px 0 #ffffff,
    2px 2px 6px rgba(0, 0, 0, 0.4);
  z-index: 10000;
  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;
  pointer-events: auto;
}

.win95-titlebar {
  background: linear-gradient(90deg, #000080 0%, #1084d0 100%);
  padding: 1px 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 14px;
}

.win95-titlebar.success {
  background: linear-gradient(90deg, #008000 0%, #00a000 100%);
}

.win95-title {
  color: #fff;
  font-size: 9px;
  font-weight: bold;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.win95-titlebar-buttons {
  display: flex;
  gap: 1px;
}

.win95-content {
  display: flex;
  padding: 6px 6px 4px;
  gap: 6px;
}

.win95-icon-section {
  flex-shrink: 0;
}

.win95-key-icon {
  font-size: 20px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.win95-form-section {
  flex: 1;
  min-width: 0;
}

.win95-message {
  font-size: 9px;
  color: #000;
  margin: 0 0 4px 0;
  line-height: 1.2;
}

.win95-field {
  margin-bottom: 4px;
}

.win95-label {
  font-size: 9px;
  color: #000;
  display: block;
  margin-bottom: 1px;
}

.win95-input-display {
  background: #fff;
  border: 1px inset #808080;
  padding: 2px 3px;
  font-size: 9px;
  min-height: 12px;
  font-family: 'MS Sans Serif', Tahoma, sans-serif;
}

.win95-input-display.password {
  letter-spacing: 1px;
}

.win95-cursor {
  animation: win95-blink 1s step-end infinite;
  color: #000;
}

@keyframes win95-blink {
  0%,
  50% {
    opacity: 1;
  }
  51%,
  100% {
    opacity: 0;
  }
}

.win95-buttons {
  display: flex;
  justify-content: center;
  gap: 4px;
  padding: 2px 6px 6px;
}

.win95-btn {
  min-width: 50px;
  height: 16px;
  background: #c0c0c0;
  border: 1px outset #dfdfdf;
  font-size: 9px;
  font-family: 'MS Sans Serif', Tahoma, sans-serif;
  cursor: pointer;
  padding: 0 6px;
}

.win95-btn:active {
  border-style: inset;
}

.win95-btn.active {
  border: 1px solid #000;
  outline: 1px dotted #000;
  outline-offset: -3px;
}

.win95-btn.disabled {
  color: #808080;
  text-shadow: 1px 1px 0 #fff;
  cursor: not-allowed;
}

.win95-status {
  background: #c0c0c0;
  border-top: 1px solid #808080;
  padding: 2px 4px;
  font-size: 8px;
  color: #000;
  text-align: center;
}

/* Success Dialog - Compact */
.win95-success-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -110%);
  width: 70%;
  max-width: 140px;
  background: #c0c0c0;
  border: 2px outset #dfdfdf;
  box-shadow:
    inset -1px -1px 0 #808080,
    inset 1px 1px 0 #ffffff,
    2px 2px 6px rgba(0, 0, 0, 0.4);
  z-index: 10000;
  animation: win95-appear 0.2s ease-out;
  pointer-events: auto;
}

@keyframes win95-appear {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

.win95-success-content {
  padding: 10px;
  text-align: center;
}

.win95-success-icon {
  font-size: 24px;
  margin-bottom: 6px;
}

.win95-success-text {
  font-family: 'MS Sans Serif', Tahoma, sans-serif;
  font-size: 9px;
  font-weight: bold;
  color: #008000;
  margin: 0;
}

/* Dell Laptop Keyboard - 3D base, light from top-left */
.laptop-keyboard {
  background: linear-gradient(
    168deg,
    #989898 0%,
    #848484 20%,
    #707070 50%,
    #5e5e5e 80%,
    #4e4e4e 100%
  );
  border-radius: 0 0 10px 10px;
  padding: 10px 12px 14px;
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.55),
    0 5px 12px rgba(0, 0, 0, 0.4),
    inset 4px 4px 8px rgba(255, 255, 255, 0.22),
    inset -3px -3px 6px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
  border: 1px solid #7a7a7a;
  border-bottom-color: #454545;
  border-left-color: #828282;
  border-right-color: #6a6a6a;
  border-top: none;
  position: relative;
  width: 100%;
}

/* Dell logo between mute and power buttons */
.keyboard-dell-logo {
  height: 24px;
  width: auto;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.75;
}

.keyboard-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 6px;
}

.keyboard-top-left,
.keyboard-top-right {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.keyboard-top-right {
  justify-content: flex-end;
}

.keyboard-top-center {
  flex: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px;
}

/* Speaker grilles - stretched like real laptop, recessed perforated look */
.speaker-grille {
  flex: 1;
  min-width: 50px;
  height: 12px;
  background: repeating-linear-gradient(0deg, #1e1e1e 0px, #1e1e1e 1px, #363636 1px, #363636 2px);
  border-radius: 2px;
  border: 1px solid #181818;
  box-shadow:
    inset 0 3px 6px rgba(0, 0, 0, 0.75),
    inset 0 1px 0 rgba(0, 0, 0, 0.5),
    0 1px 0 rgba(255, 255, 255, 0.04);
}

.mute-button {
  width: 24px;
  height: 18px;
  flex-shrink: 0;
  background: linear-gradient(175deg, #4a4a4a 0%, #3a3a3a 45%, #2a2a2a 100%);
  border-radius: 3px;
  border: 1px solid #4a4a4a;
  border-top-color: #5a5a5a;
  box-shadow:
    0 1px 0 #1a1a1a,
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    inset 0 -1px 0 rgba(0, 0, 0, 0.35);
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.mute-button:hover {
  background: linear-gradient(180deg, #555 0%, #444 50%, #333 100%);
}

.mute-button:active {
  transform: scale(0.95);
}

.mute-button .mute-button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.75);
}

.mute-button.muted .mute-button-icon {
  color: #cc2222;
  animation: mute-icon-pulse 1.5s ease-in-out infinite;
}

@keyframes mute-icon-pulse {
  0%,
  100% {
    filter: drop-shadow(0 0 3px #cc2222) drop-shadow(0 0 8px rgba(204, 34, 34, 0.8));
    opacity: 1;
  }
  50% {
    filter: drop-shadow(0 0 6px #cc2222) drop-shadow(0 0 14px rgba(204, 34, 34, 0.9));
    opacity: 0.9;
  }
}

.mute-button.muted {
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.4),
    0 1px 0 #1a1a1a;
}

.power-button {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  background: linear-gradient(175deg, #5a5a5a 0%, #484848 45%, #363636 100%);
  border-radius: 50%;
  border: 1px solid #4a4a4a;
  border-top-color: #666;
  box-shadow:
    0 1px 0 #1e1e1e,
    inset 0 1px 0 rgba(255, 255, 255, 0.12),
    inset 0 -1px 0 rgba(0, 0, 0, 0.4);
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.power-button:hover {
  background: linear-gradient(180deg, #666 0%, #555 50%, #444 100%);
  transform: scale(1.05);
}

.power-button:active {
  transform: scale(0.95);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.6);
}

.power-icon {
  font-size: 10px;
  color: #888;
  line-height: 1;
}

.power-button.on .power-icon {
  color: #00ff00;
  text-shadow:
    0 0 6px #00ff00,
    0 0 12px rgba(0, 255, 0, 0.6);
}

.power-button.off .power-icon {
  color: #666;
}

.power-button.booting .power-icon {
  color: #ffaa00;
}

.power-button.booting {
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.5),
    0 1px 0 #1e1e1e;
}

.power-button.booting .power-icon {
  animation: power-icon-pulse-yellow 0.5s ease-in-out infinite;
}

@keyframes power-icon-pulse-yellow {
  0%,
  100% {
    text-shadow:
      0 0 4px #ffaa00,
      0 0 8px rgba(255, 170, 0, 0.6);
  }
  50% {
    text-shadow:
      0 0 8px #ffaa00,
      0 0 16px rgba(255, 170, 0, 0.9);
  }
}

.power-button.shutting-down {
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.5),
    0 1px 0 #1e1e1e;
}

.power-button.shutting-down .power-icon {
  animation: power-icon-pulse-orange 0.3s ease-in-out infinite;
}

@keyframes power-icon-pulse-orange {
  0%,
  100% {
    text-shadow:
      0 0 4px #ff6600,
      0 0 8px rgba(255, 102, 0, 0.6);
  }
  50% {
    text-shadow:
      0 0 8px #ff6600,
      0 0 16px rgba(255, 102, 0, 0.9);
  }
}

/* Power LED indicator - on the power button */
.power-button::after {
  content: '';
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #00ff00;
  box-shadow: 0 0 3px rgba(0, 255, 0, 0.8);
  transition: all 0.3s ease;
}

.power-button.off::after {
  background: #444;
  box-shadow: none;
}

/* Lid open + powered off (not booting): power icon pulses red */
.dell-laptop.open .power-button.off:not(.booting):not(.shutting-down) {
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.5),
    0 1px 0 #1e1e1e;
}

.dell-laptop.open .power-button.off:not(.booting):not(.shutting-down) .power-icon {
  color: #cc2222;
  animation: power-icon-pulse-red 1.2s ease-in-out infinite;
}

.dell-laptop.open .power-button.off:not(.booting):not(.shutting-down)::after {
  opacity: 0;
}

@keyframes power-icon-pulse-red {
  0%,
  100% {
    text-shadow:
      0 0 4px #cc2222,
      0 0 8px rgba(204, 34, 34, 0.6);
  }
  50% {
    text-shadow:
      0 0 8px #cc2222,
      0 0 16px rgba(204, 34, 34, 0.9);
  }
}

.power-button.booting::after,
.power-button.shutting-down::after {
  opacity: 0;
}

.dell-laptop.closed .power-button::after {
  background: #555;
  box-shadow: none;
}

/* Boot Screen */
.boot-screen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
}

.boot-screen.off {
  background: #0a0a0a;
}

.boot-screen.booting {
  align-items: flex-start;
  justify-content: flex-start;
  padding: 8px;
}

.power-off-text {
  color: #e0e0e0;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
  letter-spacing: 0.5px;
}

@keyframes pulse-dim {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
}

.boot-terminal {
  font-family: 'Courier New', monospace;
  font-size: 9px;
  color: #00ff00;
  line-height: 1.4;
  text-shadow: 0 0 2px #00ff00;
  width: 100%;
  overflow: hidden;
}

.boot-line {
  white-space: nowrap;
  overflow: hidden;
  animation: type-in 0.1s ease-out;
}

@keyframes type-in {
  from {
    opacity: 0;
    transform: translateX(-5px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.boot-cursor {
  display: inline-block;
  animation: cursor-blink 0.5s step-end infinite;
}

@keyframes cursor-blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

/* Windows 95 Shutdown Screen */
.shutdown-screen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #008080;
  z-index: 55;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: shutdown-fade-in 0.5s ease-out;
}

@keyframes shutdown-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.shutdown-content {
  text-align: center;
  animation: shutdown-appear 0.8s ease-out 0.3s both;
}

@keyframes shutdown-appear {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.shutdown-logo {
  margin-bottom: 16px;
}

.win95-logo-img {
  width: 80px;
  height: auto;
  animation: flag-pulse 1.5s ease-in-out infinite;
}

@keyframes flag-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* Screen off state - pure black */
.laptop-screen.screen-off {
  background: #000 !important;
}

.shutdown-text {
  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;
  font-size: 18px;
  color: #ffcc00;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  margin-bottom: 4px;
}

.shutdown-subtext {
  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;
  font-size: 18px;
  color: #ffcc00;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.power-button.shutting-down .power-icon {
  color: #ff6600;
  animation: power-icon-pulse-orange 0.3s ease-in-out infinite;
}

/* Typing line style */
.boot-line.typing {
  color: #00ff00;
}

/* Windows 95 Startup Video */
.startup-video-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  z-index: 52;
  display: flex;
  align-items: center;
  justify-content: center;
}

.startup-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.keyboard-keys {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
  background: linear-gradient(168deg, #3e3e3e 0%, #323232 40%, #282828 75%, #1e1e1e 100%);
  padding: 8px 10px;
  border-radius: 6px;
  box-shadow:
    inset 4px 4px 10px rgba(0, 0, 0, 0.6),
    inset -2px -2px 4px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
  border: 1px solid #2e2e2e;
  border-top-color: #3a3a3a;
  border-left-color: #323232;
  transition: box-shadow 0.3s ease;
}

.keyboard-keys.active {
  box-shadow:
    inset 0 2px 4px rgba(0, 0, 0, 0.4),
    0 0 15px rgba(0, 255, 0, 0.2);
}

.key-row {
  display: flex;
  gap: 3px;
  justify-content: center;
  align-items: center;
}

.key-row.bottom {
  margin-top: 2px;
}

/* Dell-style keys: fuller, easier to read */
.key {
  width: 21px;
  height: 15px;
  background: linear-gradient(175deg, #4a4a4a 0%, #3a3a3a 35%, #2e2e2e 70%, #242424 100%);
  border-radius: 4px;
  box-shadow:
    0 2px 0 #161616,
    0 1px 0 rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    inset 0 -1px 0 rgba(0, 0, 0, 0.35);
  border: 1px solid #2a2a2a;
  border-top-color: #3a3a3a;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.1s ease;
}

.key-label {
  font-family: 'Segoe UI', system-ui, sans-serif;
  font-size: 7px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.65);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  pointer-events: none;
}

.key.clickable {
  cursor: pointer;
}

.key.clickable:hover {
  background: linear-gradient(175deg, #545454 0%, #444444 50%, #363636 100%);
  box-shadow:
    0 2px 0 #161616,
    inset 0 1px 0 rgba(255, 255, 255, 0.14),
    0 0 10px rgba(0, 255, 0, 0.25);
}

.key.clickable:hover .key-label {
  color: rgba(0, 255, 0, 0.8);
}

.key.pressed {
  background: linear-gradient(180deg, #282828 0%, #1a1a1a 100%);
  box-shadow:
    0 1px 0 #0e0e0e,
    inset 0 2px 5px rgba(0, 0, 0, 0.7),
    0 0 12px rgba(0, 255, 0, 0.4);
  transform: translateY(1px);
}

.key.pressed .key-label {
  color: #0f0;
  text-shadow: 0 0 4px #0f0;
}

.key.backspace {
  width: 34px;
}

.key.enter {
  width: 34px;
}

.key.enter .key-label {
  font-size: 6px;
  text-transform: none;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

.key.enter .key-enter-icon {
  font-size: 9px;
  line-height: 1;
  opacity: 0.9;
}

.key.shift {
  width: 34px;
  font-size: 6px;
}

.key.shift.caps-on {
  background: var(--accent, #2563eb);
  color: #fff;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
}

.key.spacebar {
  width: 110px;
}

.key.ctrl,
.key.fn,
.key.win,
.key.alt {
  width: 28px;
}

.arrow-keys {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-left: 6px;
}

.key.arrow {
  width: 15px;
  height: 9px;
}

.key.arrow.up {
  margin: 0 auto;
}

.arrow-bottom {
  display: flex;
  gap: 1px;
}

/* Trackpad area - Dell-style: one recessed unit, touchpad + buttons blended */
.trackpad-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  margin-top: 6px;
}

.trackpad-buttons {
  display: flex;
  align-items: stretch;
  gap: 0;
  order: 2;
  width: 110px;
  height: 12px;
  border: 1px solid #4a4a4a;
  border-top: none;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
  box-shadow:
    inset 0 3px 6px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.trackpad-btn {
  flex: 1;
  min-width: 0;
  height: 100%;
  background: linear-gradient(180deg, #5a5a5a 0%, #505050 50%, #464646 100%);
  border: none;
  border-radius: 0;
  box-shadow: none;
}

.trackpad-btn + .trackpad-btn {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
}

/* Red trackpoint nub - hidden since buttons are at bottom now */
.trackpoint {
  display: none;
}

/* Laptop stickers - like real business laptops */
.laptop-stickers {
  position: absolute;
  bottom: 9px;
  left: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 2;
}

.sticker {
  padding: 0;
  border-radius: 0;
  font-size: 6px;
  font-weight: bold;
  box-shadow: none;
  line-height: 0;
}

.sticker-intel {
  background: transparent;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.sticker-intel-img,
.sticker-win-img {
  height: 22px;
  width: auto;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.25)) drop-shadow(0 0 0 1px rgba(0, 0, 0, 0.06));
  opacity: 0.92;
}

.sticker-win-img {
  height: 28px;
}

.sticker-win {
  background: transparent;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

/* Touchpad - recessed 3D */
.touchpad {
  width: 110px;
  height: 55px;
  background: linear-gradient(168deg, #606060 0%, #545454 40%, #4a4a4a 80%, #424242 100%);
  border: 1px solid #4a4a4a;
  border-bottom: none;
  border-radius: 6px 6px 0 0;
  box-shadow:
    inset 3px 3px 8px rgba(0, 0, 0, 0.45),
    inset -1px -1px 2px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  order: 1;
}

/* Hide old monitor controls */
.monitor-controls {
  display: none;
}

.control-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  contain: layout style paint;
}

.control-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: #fff;
  transform: scale(1.1);
}

.control-btn:active {
  transform: scale(0.95);
}

.control-btn svg {
  width: 18px;
  height: 18px;
  fill: #fff;
}

.play-btn {
  width: 42px;
  height: 42px;
  border-color: #fff;
  background: rgba(255, 255, 255, 0.1);
  border-width: 2px;
}

.play-btn svg {
  width: 20px;
  height: 20px;
  fill: #fff;
}

.scanlines {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 5;
  background: repeating-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.08) 0px,
    rgba(0, 0, 0, 0.08) 1px,
    transparent 1px,
    transparent 2px
  );
}

.formula {
  position: absolute;
  font-family: 'Bebas Neue', monospace;
  font-size: 10px;
  color: var(--bb-black);
  letter-spacing: 1px;
  font-weight: bold;
  opacity: 0.4;
  animation: formula-pulse 8s ease-in-out infinite;
  will-change: opacity;
  background: var(--bb-yellow);
  padding: 2px 4px;
  border: 1px solid var(--bb-black);
  contain: layout style paint;
  transform: translateZ(0);
}
.formula:nth-child(1) {
  top: 6%;
  left: 12px;
}
.formula:nth-child(2) {
  top: 12%;
  right: 12px;
  animation-delay: 2s;
}
.formula:nth-child(3) {
  bottom: 14%;
  left: 12px;
  animation-delay: 4s;
}
.formula:nth-child(4) {
  bottom: 8%;
  right: 12px;
  animation-delay: 6s;
}

.biohazard {
  position: absolute;
  width: 50px;
  height: 50px;
  opacity: 0.25;
  animation: bio-pulse 5s ease-in-out infinite;
  will-change: opacity;
  fill: var(--bb-black);
}
.biohazard.left {
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
}
.biohazard.right {
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  animation-delay: 2.5s;
}

/* Crystal Slider Styles - Compact */
.crystal-slider-container {
  position: relative;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  animation: fade-in 0.8s ease-out 0.5s forwards;
  opacity: 0;
  width: 85%;
  max-width: 280px;
}

.crystal-slider-track {
  position: relative;
  width: 100%;
  height: 48px;
  background: transparent;
  border-radius: 24px;
  overflow: visible;
  user-select: none;
  -webkit-user-select: none;
  border: none;
  box-shadow: none;
}

.crystal-slider-track.locked {
  cursor: text;
  background: transparent;
  border: none;
}

.crystal-slider-track.unlocked {
  cursor: default;
}

.crystal-slider-track.dragging {
  /* no background change */
}

.crystal-slider-track.success {
  /* no background change */
}

.slider-progress-fill {
  display: none;
}

/* Slider text display */
.slider-text-display {
  position: absolute;
  left: 110px;
  top: 50%;
  transform: translateY(-50%);
  width: calc(100% - 120px);
  font-family: 'Bebas Neue', sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-align: left;
  z-index: 5;
  padding: 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.crystal-slider-track.unlocked .slider-text-display {
  color: #0f0;
  text-shadow: 0 0 8px rgba(0, 255, 0, 0.5);
  animation: text-glow 1.5s ease-in-out infinite;
}

@keyframes text-glow {
  0%,
  100% {
    text-shadow: 0 0 8px rgba(0, 255, 0, 0.5);
  }
  50% {
    text-shadow:
      0 0 15px rgba(0, 255, 0, 0.8),
      0 0 25px rgba(0, 255, 0, 0.4);
  }
}

.crystal-slider-track.success .slider-text-display {
  color: var(--green-dark);
}

.crystal-thumb {
  position: absolute;
  top: 50%;
  margin-top: -32px;
  width: 100px;
  height: 64px;
  cursor: grab;
  z-index: 10;
  transition:
    left 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    filter 0.2s ease,
    opacity 0.2s ease,
    transform 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  box-sizing: border-box;
}

.crystal-thumb.dragging {
  transition: none;
}

.crystal-thumb:not(.dragging) {
  transition:
    left 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
    filter 0.2s ease,
    opacity 0.2s ease,
    transform 0.15s ease;
}

.crystal-thumb.disabled {
  cursor: not-allowed;
  opacity: 0.4;
  filter: grayscale(0.5);
}

.crystal-thumb:active,
.crystal-thumb.dragging {
  cursor: grabbing;
}

.crystal-thumb.success {
  animation: crystal-success 0.6s ease-out;
}

@keyframes crystal-success {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.3);
  }
  60% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.crystal-image {
  width: auto;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center center;
  filter: drop-shadow(0 4px 8px rgba(125, 211, 252, 0.5));
  transition:
    filter 0.2s ease,
    transform 0.2s ease;
  pointer-events: none;
  display: block;
  margin: 0 auto;
}

.crystal-thumb:hover .crystal-image,
.crystal-thumb.dragging .crystal-image {
  filter: drop-shadow(0 6px 15px rgba(125, 211, 252, 0.7)) brightness(1.1);
  transform: scale(1.05);
}

.crystal-thumb.success .crystal-image {
  filter: drop-shadow(0 8px 20px rgba(30, 123, 52, 0.6)) brightness(1.2);
}

.crystal-image.money-image {
  width: 180%;
  height: auto;
  max-height: none;
  filter: drop-shadow(0 4px 12px rgba(34, 197, 94, 0.6));
}

.crystal-glow {
  position: absolute;
  width: 70px;
  height: 70px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: radial-gradient(
    ellipse at center,
    rgba(125, 211, 252, 0.4) 0%,
    rgba(125, 211, 252, 0.1) 40%,
    transparent 70%
  );
  border-radius: 50%;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
  animation: glow-pulse 2s ease-in-out infinite;
}

.crystal-thumb:hover .crystal-glow,
.crystal-thumb.dragging .crystal-glow {
  opacity: 1;
}

.crystal-thumb.success .crystal-glow {
  background: radial-gradient(
    ellipse at center,
    rgba(30, 123, 52, 0.5) 0%,
    rgba(30, 123, 52, 0.2) 40%,
    transparent 70%
  );
  opacity: 1;
}

@keyframes glow-pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}

.slider-hint {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0;
  margin-top: 8px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}

@keyframes hint-pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.8;
  }
}

.landing-container.unlocking {
  animation: unlock 1.2s ease-in-out forwards;
}

@keyframes unlock {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.02);
  }
  100% {
    opacity: 0;
    transform: scale(1.1);
  }
}

.vignette {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
  background: radial-gradient(ellipse at center, transparent 30%, var(--black-rgba-70) 100%);
}

@keyframes smoke-rise {
  0% {
    transform: translateY(100vh) scale(0.5);
    opacity: 0;
  }
  10% {
    opacity: 0.5;
  }
  90% {
    opacity: 0.15;
  }
  100% {
    transform: translateY(-100vh) scale(1.8);
    opacity: 0;
  }
}
@keyframes toxic-drift {
  0%,
  100% {
    transform: translateY(80vh) scale(0.8);
    opacity: 0;
  }
  20% {
    opacity: 0.4;
  }
  80% {
    opacity: 0.15;
  }
}
@keyframes sparkle {
  0%,
  100% {
    opacity: 0.2;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.3);
  }
}
@keyframes stripe-move {
  to {
    background-position: 400px 0;
    transform: translateZ(0);
  }
}
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes video-appear {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes border-shift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}
@keyframes formula-pulse {
  0%,
  100% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.45;
  }
}
@keyframes bio-pulse {
  0%,
  100% {
    opacity: 0.05;
  }
  50% {
    opacity: 0.12;
  }
}
@keyframes tagline-appear {
  to {
    opacity: 0.5;
  }
}

/* Loading Modal Styles - Yellow to White Transition */
.loading-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--bb-yellow);
  animation: bg-yellow-to-white 2.5s ease-in-out forwards;
}

@keyframes bg-yellow-to-white {
  0% {
    background: var(--bb-yellow);
  }
  40% {
    background: var(--bb-yellow);
  }
  100% {
    background: #ffffff;
  }
}

.loading-modal-overlay.phase-1 {
  opacity: 1;
}

/* Top Text */
.loading-top-text {
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: all 0.8s ease-out;
}

.loading-top-text.visible {
  opacity: 1;
}

.loading-top-text span {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: var(--bb-black);
  letter-spacing: 6px;
  text-transform: uppercase;
}

/* Center Logo */
.loading-center {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transform: scale(0.3);
  transition: all 1.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.loading-center.visible {
  opacity: 1;
  transform: scale(1);
}

.heisenberg-logo {
  width: 180px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
  animation: logo-settle 1.5s ease-out forwards;
}

@keyframes logo-settle {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  60% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Bottom Text */
.loading-bottom-text {
  position: absolute;
  bottom: 140px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: all 0.8s ease-out;
}

.loading-bottom-text.visible {
  opacity: 1;
}

.loading-bottom-text span {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 28px;
  font-weight: bold;
  color: var(--bb-black);
  letter-spacing: 8px;
  text-transform: uppercase;
}

/* Progress Bar */
.loading-progress-bar {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 3px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.5s ease-out;
}

.loading-progress-bar.visible {
  opacity: 1;
}

.progress-fill {
  height: 100%;
  width: 0%;
  background: var(--bb-black);
  border-radius: 2px;
  animation: progress-load 1.2s ease-out forwards;
}

@keyframes progress-load {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

/* Error Modal - Red Background */
.error-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #8b0000;
  animation: error-flash 0.3s ease-out;
}

@keyframes error-flash {
  0% {
    opacity: 0;
    background: #ff0000;
  }
  50% {
    background: #ff0000;
  }
  100% {
    opacity: 1;
    background: #8b0000;
  }
}

.error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  animation: error-shake 0.5s ease-out;
}

@keyframes error-shake {
  0%,
  100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-20px);
  }
  40% {
    transform: translateX(20px);
  }
  60% {
    transform: translateX(-15px);
  }
  80% {
    transform: translateX(15px);
  }
}

.error-heisenberg {
  width: 150px;
  height: auto;
  filter: brightness(0) invert(1) drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  animation: error-pulse 1s ease-in-out infinite;
}

@keyframes error-pulse {
  0%,
  100% {
    filter: brightness(0) invert(1) drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  50% {
    filter: brightness(0) invert(1) drop-shadow(0 0 40px rgba(255, 255, 255, 0.8));
  }
}

.error-text {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 36px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 8px;
  text-transform: uppercase;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
}

.error-subtext {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 3px;
  text-transform: uppercase;
}

/* Mobile responsive - all phone sizes */
@media (max-width: 430px) {
  .landing-container {
    max-width: 100vw;
  }
  .periodic-elements {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }
  .element-tile {
    height: 76px;
    padding: 10px 8px 8px;
  }
  .element-symbol {
    font-size: 28px;
  }
  .element-name {
    font-size: 8px;
    letter-spacing: 1.5px;
  }
  .smoke {
    width: 120px;
    height: 120px;
    filter: blur(25px);
  }
  .toxic-smoke {
    width: 150px;
    height: 150px;
    filter: blur(35px);
  }
  .formula {
    font-size: 9px;
  }
  .biohazard {
    width: 30px;
    height: 30px;
  }
  .heisenberg-image {
    width: 150px;
  }
  .loading-letter {
    font-size: 32px;
  }
  .loading-modal {
    padding: 30px 20px;
  }
  .lab-monitor {
    width: 94%;
    max-width: 100%;
  }
  .touchpad {
    width: 80px;
    height: 40px;
  }
  .key.spacebar {
    width: 60px;
  }
  .crystal-slider-container {
    width: 88%;
    max-width: 100%;
    margin-top: 16px;
  }
  .crystal-slider-track {
    height: 44px;
  }
  .crystal-thumb {
    width: 120px;
    height: 85px;
    margin-top: -42px;
  }
  .slider-text-display {
    left: 130px;
    width: calc(100% - 140px);
    font-size: 14px;
    letter-spacing: 2px;
  }

  .key-label {
    font-size: 5px;
  }

  .video-login-popup {
    width: 85%;
  }

  .login-password-display {
    font-size: 14px;
    letter-spacing: 2px;
  }
  .hazmat-stripe {
    height: 40px;
  }
}

/* Small phones (iPhone SE, Galaxy S8, etc.) */
@media (max-width: 375px) {
  .lab-monitor {
    width: 96%;
  }
  .crystal-slider-container {
    width: 90%;
    margin-top: 14px;
  }
  .crystal-slider-track {
    height: 42px;
  }
  .crystal-thumb {
    width: 100px;
    height: 75px;
    margin-top: -37px;
  }
  .slider-text-display {
    left: 110px;
    width: calc(100% - 120px);
    font-size: 12px;
    letter-spacing: 1px;
  }

  .key {
    width: 16px;
    height: 12px;
  }

  .key-label {
    font-size: 4px;
  }

  .key.spacebar {
    width: 70px;
  }

  .key.backspace,
  .key.enter,
  .key.shift {
    width: 24px;
  }
  .monitor-header {
    padding: 6px 10px;
  }
  .monitor-dots .dot {
    width: 8px;
    height: 8px;
  }
  .control-btn {
    width: 32px;
    height: 32px;
  }
  .play-btn {
    width: 38px;
    height: 38px;
  }
  .biohazard {
    width: 24px;
    height: 24px;
  }
  .formula {
    font-size: 8px;
  }
  .hazmat-stripe {
    height: 35px;
  }
  .loading-top-text span {
    font-size: 18px;
    letter-spacing: 4px;
  }
  .loading-bottom-text span {
    font-size: 22px;
    letter-spacing: 5px;
  }
  .heisenberg-logo {
    width: 140px;
  }
  .error-text {
    font-size: 28px;
    letter-spacing: 5px;
  }
  .error-subtext {
    font-size: 12px;
    letter-spacing: 2px;
    text-align: center;
    padding: 0 20px;
  }
}

/* Extra small phones */
@media (max-width: 320px) {
  .crystal-slider-container {
    width: 92%;
    margin-top: 12px;
  }
  .crystal-slider-track {
    height: 40px;
  }
  .crystal-thumb {
    width: 90px;
    height: 65px;
    margin-top: -32px;
  }
  .slider-text-display {
    left: 95px;
    width: calc(100% - 105px);
    font-size: 11px;
  }

  .key {
    width: 14px;
    height: 10px;
  }

  .key.spacebar {
    width: 55px;
  }
  .lab-monitor {
    width: 98%;
  }
}

/* Tall phones (iPhone X/11/12/13/14 Pro Max, etc.) */
@media (min-height: 800px) {
  .crystal-slider-container {
    margin-top: 24px;
  }
}

/* Short phones */
@media (max-height: 650px) {
  .lab-monitor {
    width: 85%;
  }
  .crystal-slider-container {
    margin-top: 16px;
  }
  .hazmat-stripe {
    height: 30px;
  }
  .title-container {
    margin-bottom: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/enter-page/enter.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,wCAAwC;EACxC,wCAAwC;EACxC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;EAC3C,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,uCAAuC;EACvD,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,4EAA4E;EAC5E,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wFAAwF;EACxF,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yFAAyF;EACzF,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kFAAkF;EAClF,0FAA0F;AAC5F;;AAEA;EACE;IACE,iEAAiE;IACjE,aAAa;EACf;EACA;IACE,uEAAuE;IACvE,YAAY;EACd;EACA;IACE,yEAAyE;IACzE,aAAa;EACf;EACA;IACE,wEAAwE;IACxE,YAAY;EACd;EACA;IACE,0EAA0E;IAC1E,UAAU;EACZ;AACF;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE;IACE,wFAAwF;IACxF,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE;mGAC+F;EACjG;EACA;IACE;kGAC8F;EAChG;EACA;IACE;mGAC+F;EACjG;EACA;IACE;kGAC8F;EAChG;EACA;IACE;mGAC+F;IAC/F,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE;4FACwF;IACxF,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,MAAM;EACN,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,2FAA2F;EAC3F,yEAAyE;EACzE,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;;;6CAG2C;EAC3C,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB;;yBAEuB;AACzB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,0DAA0D;EAC1D,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;GAKC;EACD,YAAY;AACd;AACA;EACE,uCAAuC;EACvC;;oEAEkE;AACpE;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB;;;;;GAKC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,0DAA0D;EAC1D,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,mDAAmD;AACnD;EACE,UAAU;EACV,gBAAgB;EAChB,mDAAmD;EACnD,UAAU;EACV,2BAA2B;EAC3B,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uFAAuF;EACvF,4BAA4B;EAC5B;iGAC+F;AACjG;;AAEA,2DAA2D;AAC3D;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,uDAAuD;EACvD,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,yCAAyC;EACzC;;;;2CAIyC;AAC3C;;AAEA,oEAAoE;AACpE;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA,gEAAgE;AAChE;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB;;;;;;;GAOC;EACD,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;0CAGwC;EACxC,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,uFAAuF;EACvF,0BAA0B;EAC1B,gBAAgB;EAChB;;;qCAGmC;EACnC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE;;;;;;;GAOC;EACD,4BAA4B;EAC5B,oBAAoB;EACpB;;;;2CAIyC;EACzC,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0EAA0E;EAC1E,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,6CAA6C;EAC7C,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,UAAU;EACV,UAAU;EACV,eAAe;EACf,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,eAAe;EACf,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,eAAe;EACf,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,SAAS;EACT,eAAe;EACf,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,eAAe;EACf,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,UAAU;EACV,UAAU;EACV,eAAe;EACf,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8DAA8D;EAC9D,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC;;qCAEmC;AACrC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B;;;2CAGyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,4DAA4D;EAC5D,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,4DAA4D;EAC5D,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,4DAA4D;AAC9D;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA,iEAAiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,6CAA6C;EAC7C,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0DAA0D;EAC1D,sBAAsB;EACtB,kBAAkB;EAClB;;0CAEwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;EAC1B,4DAA4D;EAC5D,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ;;;;;;;GAOC;EACD,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,0EAA0E;EAC1E,YAAY;EACZ,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf;;kCAEgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,iGAAiG;EACjG,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gGAAgG;EAChG,kDAAkD;AACpD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,0EAA0E;EAC1E,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B;;;kCAGgC;EAChC,cAAc;EACd,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,gDAAgD;EAChD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B;;;kCAGgC;EAChC,cAAc;EACd,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE;;;;;;;GAOC;EACD,4BAA4B;EAC5B,uBAAuB;EACvB;;;;;2CAKyC;EACzC,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,OAAO;EACP,eAAe;EACf,YAAY;EACZ,+FAA+F;EAC/F,kBAAkB;EAClB,yBAAyB;EACzB;;;qCAGmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0EAA0E;EAC1E,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB;;;sCAGoC;EACpC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE;;IAEE,gFAAgF;IAChF,UAAU;EACZ;EACA;IACE,iFAAiF;IACjF,YAAY;EACd;AACF;;AAEA;EACE;;mBAEiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0EAA0E;EAC1E,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB;;;qCAGmC;EACnC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iEAAiE;EACjE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd;;iCAE+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;mBAEiB;AACnB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE;;IAEE;;oCAEgC;EAClC;EACA;IACE;;qCAEiC;EACnC;AACF;;AAEA;EACE;;mBAEiB;AACnB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE;;IAEE;;oCAEgC;EAClC;EACA;IACE;;qCAEiC;EACnC;AACF;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE;;mBAEiB;AACnB;;AAEA;EACE,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;IAEE;;oCAEgC;EAClC;EACA;IACE;;qCAEiC;EACnC;AACF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,kCAAkC;AAClC;EACE,2BAA2B;AAC7B;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,4DAA4D;AAC9D;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,uFAAuF;EACvF,iBAAiB;EACjB,kBAAkB;EAClB;;;2CAGyC;EACzC,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;;iCAE+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,YAAY;EACZ,uFAAuF;EACvF,kBAAkB;EAClB;;;;sCAIoC;EACpC,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0EAA0E;EAC1E;;;kCAGgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D;;;iCAG+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB;;2CAEyC;AAC3C;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,0EAA0E;EAC1E,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,gEAAgE;AAChE;EACE,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,6FAA6F;EAC7F,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,YAAY;EACZ,uFAAuF;EACvF,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B;;;2CAGyC;EACzC,QAAQ;AACV;;AAEA,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV;;;;;;GAMC;AACH;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gDAAgD;EAChD,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,OAAO;EACP,UAAU;AACZ;AACA;EACE,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8CAA8C;EAC9C,UAAU;EACV,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE;;IAEE,yCAAyC;EAC3C;EACA;IACE;;mCAE+B;EACjC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,WAAW;EACX;;;;wBAIsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;;wBAIsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,uDAAuD;EACvD;;uBAEqB;EACrB,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,wEAAwE;EACxE,sBAAsB;AACxB;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC;;;;;GAKC;EACD,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE;;;;;GAKC;EACD,UAAU;AACZ;;AAEA;EACE;;IAEE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,0FAA0F;AAC5F;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,wCAAwC;IACxC,UAAU;EACZ;AACF;AACA;EACE;;IAEE,sCAAsC;IACtC,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;;IAEE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;;IAEE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,8EAA8E;EAC9E,8CAA8C;AAChD;;AAEA;EACE;;IAEE,8EAA8E;EAChF;EACA;IACE,8EAA8E;EAChF;AACF;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE;IACE,gBAAgB;EAClB;EACA;IACE,oDAAoD;EACtD;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;EACzC;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');\n\n:root {\n  --bb-yellow: #f4d03f;\n  --bb-yellow-dark: #d4b02f;\n  --bb-black: #000000;\n  --bb-black-80: rgba(0, 0, 0, 0.8);\n  --bb-green: #1e7b34;\n  --bb-green-dark: #145a25;\n  --bg-dark: #0a0a0a;\n  --green-primary: #1e7b34;\n  --green-dark: #145a25;\n  --yellow-accent: #f4d03f;\n  --crystal-blue: #7dd3fc;\n  --green-rgba-12: rgba(30, 123, 52, 0.12);\n  --green-rgba-25: rgba(30, 123, 52, 0.25);\n  --green-rgba-40: rgba(30, 123, 52, 0.4);\n  --green-rgba-50: rgba(30, 123, 52, 0.5);\n  --green-rgba-70: rgba(30, 123, 52, 0.7);\n  --green-rgba-80: rgba(30, 123, 52, 0.8);\n  --yellow-rgba-08: rgba(244, 208, 63, 0.08);\n  --yellow-rgba-50: rgba(244, 208, 63, 0.5);\n  --crystal-rgba-50: rgba(125, 211, 252, 0.5);\n  --white-rgba-40: rgba(255, 255, 255, 0.4);\n  --white-rgba-50: rgba(255, 255, 255, 0.5);\n  --white-rgba-60: rgba(255, 255, 255, 0.6);\n  --black-rgba-50: rgba(0, 0, 0, 0.5);\n  --black-rgba-70: rgba(0, 0, 0, 0.7);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\nhtml,\nbody,\n#root {\n  width: 100%;\n  height: 100%;\n  height: 100dvh; /* Dynamic viewport height for mobile */\n  min-height: -webkit-fill-available;\n  overflow: hidden;\n  background: var(--bb-black);\n}\n\n.landing-container {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%) translateZ(0);\n  width: 100%;\n  max-width: 430px;\n  height: 100%;\n  height: 100dvh;\n  min-height: -webkit-fill-available;\n  background: url('/images/road-texture.webp') center center / cover no-repeat;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  contain: strict;\n  box-shadow: 0 0 60px rgba(0, 0, 0, 0.8);\n  position: relative;\n  isolation: isolate;\n  will-change: transform;\n  backface-visibility: hidden;\n}\n\n.landing-about-link {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  z-index: 100;\n  font-size: 12px;\n  color: var(--bb-yellow, #f4d03f);\n  text-decoration: none;\n  opacity: 0.9;\n}\n.landing-about-link:hover {\n  text-decoration: underline;\n  opacity: 1;\n}\n\n.landing-container::before {\n  display: none;\n}\n\n.smoke-layer {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n  contain: strict;\n}\n.smoke {\n  position: absolute;\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(ellipse at center, var(--green-rgba-12) 0%, transparent 70%);\n  border-radius: 50%;\n  filter: blur(40px);\n  animation: smoke-rise 20s ease-in-out infinite;\n  will-change: transform;\n  contain: layout style paint;\n}\n.smoke:nth-child(1) {\n  left: 5%;\n}\n.smoke:nth-child(2) {\n  left: 20%;\n  animation-delay: 4s;\n  width: 250px;\n  height: 250px;\n}\n.smoke:nth-child(3) {\n  left: 35%;\n  animation-delay: 8s;\n}\n.smoke:nth-child(4) {\n  left: 50%;\n  animation-delay: 2s;\n  width: 180px;\n  height: 180px;\n}\n.smoke:nth-child(5) {\n  left: 65%;\n  animation-delay: 6s;\n}\n.smoke:nth-child(6) {\n  left: 80%;\n  animation-delay: 10s;\n  width: 220px;\n  height: 220px;\n}\n\n.toxic-smoke {\n  position: absolute;\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(ellipse at center, var(--yellow-rgba-08) 0%, transparent 70%);\n  border-radius: 50%;\n  filter: blur(50px);\n  animation: toxic-drift 30s ease-in-out infinite;\n  will-change: transform;\n  contain: layout style paint;\n}\n.toxic-smoke:nth-child(1) {\n  left: 10%;\n}\n.toxic-smoke:nth-child(2) {\n  left: 70%;\n  animation-delay: 15s;\n}\n\n.crystals {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  contain: strict;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.meth-crystal {\n  position: absolute;\n  top: -60px;\n  object-fit: contain;\n  animation: crystal-fall linear infinite;\n  will-change: transform;\n  contain: layout style paint;\n  opacity: 0.85;\n}\n\n.meth-crystal::before {\n  content: '';\n  position: absolute;\n  width: 60%;\n  height: 60%;\n  top: 20%;\n  left: 20%;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, transparent 100%);\n  clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n}\n\n@keyframes crystal-fall {\n  0% {\n    transform: translateY(0) translateX(0) rotate(0deg) translateZ(0);\n    opacity: 0.85;\n  }\n  25% {\n    transform: translateY(25vh) translateX(5px) rotate(90deg) translateZ(0);\n    opacity: 0.8;\n  }\n  50% {\n    transform: translateY(50vh) translateX(-5px) rotate(180deg) translateZ(0);\n    opacity: 0.75;\n  }\n  75% {\n    transform: translateY(75vh) translateX(8px) rotate(270deg) translateZ(0);\n    opacity: 0.6;\n  }\n  100% {\n    transform: translateY(100vh) translateX(-8px) rotate(360deg) translateZ(0);\n    opacity: 0;\n  }\n}\n\n/* Falling pants container - behind laptop, same as crystals/ice */\n.falling-pants-container {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  contain: strict;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.falling-pants {\n  position: absolute;\n  top: -120px;\n  object-fit: contain;\n  animation: pants-fall linear infinite;\n  will-change: transform;\n  contain: layout style paint;\n  opacity: 0.9;\n  filter: drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.3));\n}\n\n@keyframes pants-fall {\n  0% {\n    transform: translateY(0) translateX(0) rotate(var(--start-rotation, 0deg)) translateZ(0);\n    opacity: 0;\n  }\n  5% {\n    opacity: 0.9;\n  }\n  15% {\n    transform: translateY(15vh) translateX(calc(var(--sway-amount, 30px) * -1))\n      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.15)) translateZ(0);\n  }\n  30% {\n    transform: translateY(30vh) translateX(var(--sway-amount, 30px))\n      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.3)) translateZ(0);\n  }\n  45% {\n    transform: translateY(45vh) translateX(calc(var(--sway-amount, 30px) * -0.8))\n      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.45)) translateZ(0);\n  }\n  60% {\n    transform: translateY(60vh) translateX(calc(var(--sway-amount, 30px) * 0.6))\n      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.6)) translateZ(0);\n  }\n  75% {\n    transform: translateY(75vh) translateX(calc(var(--sway-amount, 30px) * -0.4))\n      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg) * 0.75)) translateZ(0);\n    opacity: 0.7;\n  }\n  90% {\n    opacity: 0.4;\n  }\n  100% {\n    transform: translateY(110vh) translateX(calc(var(--sway-amount, 30px) * 0.2))\n      rotate(calc(var(--start-rotation, 0deg) + var(--rotation-speed, 90deg))) translateZ(0);\n    opacity: 0;\n  }\n}\n\n.hazmat-stripe {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 45px;\n  z-index: 10;\n  background: url('/images/warning-tape-divider.webp') center top / 100% auto no-repeat;\n}\n\n.hazmat-stripe.top {\n  top: 0;\n  background-position: center 25%;\n}\n\n.hazmat-stripe.bottom {\n  bottom: 0;\n  background-position: center 55%;\n}\n\n@keyframes text-scroll {\n  0% {\n    transform: translateX(100%) translateZ(0);\n  }\n  100% {\n    transform: translateX(-100%) translateZ(0);\n  }\n}\n\n.title-container {\n  position: relative;\n  z-index: 5;\n  margin-bottom: 22px;\n  animation: fade-in 0.8s ease-out forwards;\n  contain: layout style paint;\n  transform: translateZ(0);\n}\n.periodic-elements {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(140px, 1fr));\n  gap: 10px;\n  justify-content: center;\n  contain: layout style;\n  width: 100%;\n  max-width: 320px;\n}\n.element-tile {\n  --tile-accent: #ff9800;\n  --tile-glow: rgba(255, 152, 0, 0.35);\n  background: linear-gradient(145deg, rgba(20, 25, 35, 0.96) 0%, rgba(10, 12, 18, 0.98) 100%);\n  border: 2px solid color-mix(in srgb, var(--tile-accent) 55%, transparent);\n  border-radius: 14px;\n  padding: 12px 10px 10px;\n  width: 100%;\n  height: 88px;\n  text-align: center;\n  position: relative;\n  box-shadow:\n    0 16px 45px rgba(0, 0, 0, 0.7),\n    0 0 35px var(--tile-glow),\n    inset 0 1px 2px rgba(255, 255, 255, 0.06);\n  contain: layout style paint;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition:\n    transform 0.35s ease,\n    box-shadow 0.35s ease;\n}\n.element-tile::before {\n  content: attr(data-number);\n  position: absolute;\n  top: 6px;\n  right: 10px;\n  font-size: 10px;\n  color: color-mix(in srgb, var(--tile-accent) 80%, #ffffff);\n  font-family: 'Bebas Neue', sans-serif;\n  text-shadow: 0 0 18px var(--tile-glow);\n}\n.element-tile::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    color-mix(in srgb, var(--tile-accent) 65%, #ffffff),\n    transparent\n  );\n  opacity: 0.5;\n}\n.element-tile:hover {\n  transform: translateY(-6px) scale(1.02);\n  box-shadow:\n    0 24px 65px var(--tile-glow),\n    0 0 70px color-mix(in srgb, var(--tile-accent) 45%, transparent);\n}\n.element-tile:nth-child(1) {\n  --tile-accent: #ff9800;\n  --tile-glow: rgba(255, 152, 0, 0.35);\n}\n.element-tile:nth-child(2) {\n  --tile-accent: #00e5ff;\n  --tile-glow: rgba(0, 229, 255, 0.35);\n}\n.element-tile:nth-child(3) {\n  --tile-accent: #e040fb;\n  --tile-glow: rgba(224, 64, 251, 0.35);\n}\n.element-tile:nth-child(4) {\n  --tile-accent: #22c55e;\n  --tile-glow: rgba(34, 197, 94, 0.35);\n}\n.element-symbol {\n  font-family: 'Bebas Neue', sans-serif;\n  font-size: 34px;\n  letter-spacing: 1px;\n  line-height: 1;\n  font-weight: 800;\n  background: linear-gradient(\n    135deg,\n    #ffffff 0%,\n    var(--tile-accent) 60%,\n    color-mix(in srgb, var(--tile-accent) 80%, #000000) 100%\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  filter: drop-shadow(0 0 14px var(--tile-glow));\n}\n.element-name {\n  font-size: 9px;\n  color: color-mix(in srgb, var(--tile-accent) 85%, #ffffff);\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  line-height: 1;\n  margin-top: 6px;\n  font-weight: 700;\n  text-shadow: 0 0 12px var(--tile-glow);\n}\n\n/* Dell Latitude D630 Laptop - Breaking Bad Style */\n.lab-monitor {\n  width: 92%;\n  max-width: 380px;\n  animation: video-appear 0.6s ease-out 0.3s forwards;\n  opacity: 0;\n  contain: layout style paint;\n  transform: translateZ(0);\n  margin: 0 auto;\n}\n\n.lab-monitor.dell-laptop {\n  perspective: 900px;\n  perspective-origin: 50% 28%;\n  position: relative;\n  z-index: 20;\n  isolation: isolate;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform: translateY(-10vh) translateZ(40px) rotateY(-12deg) rotateX(6deg) scale(1.02);\n  transform-style: preserve-3d;\n  filter: drop-shadow(2px 4px 4px rgba(0, 0, 0, 0.6)) drop-shadow(8px 12px 16px rgba(0, 0, 0, 0.45))\n    drop-shadow(20px 32px 40px rgba(0, 0, 0, 0.3)) drop-shadow(40px 56px 72px rgba(0, 0, 0, 0.2));\n}\n\n/* Laptop Lid (Screen portion) - folds DOWN onto keyboard */\n.laptop-lid {\n  transform-origin: bottom center;\n  transform-style: preserve-3d;\n  transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  position: relative;\n  z-index: 10;\n  width: 100%;\n}\n\n.laptop-lid.lid-dragging {\n  transition: none;\n  z-index: 100;\n}\n\n/* Open state - screen standing up, depth */\n.dell-laptop.open .laptop-lid {\n  transform: rotateX(-5deg) translateZ(2px);\n  box-shadow:\n    0 2px 6px rgba(0, 0, 0, 0.5),\n    0 8px 20px rgba(0, 0, 0, 0.35),\n    0 18px 40px rgba(0, 0, 0, 0.2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\n/* Closed state - lid folds forward 180deg to lay flat on keyboard */\n.dell-laptop.closed .laptop-lid {\n  transform: rotateX(-175deg);\n  z-index: 100;\n}\n\n/* The bezel (front of screen) - swipe down to close when open */\n.laptop-bezel {\n  backface-visibility: hidden;\n}\n\n.dell-laptop.open .laptop-bezel {\n  cursor: grab;\n  touch-action: none;\n}\n\n.dell-laptop.open .laptop-bezel:active {\n  cursor: grabbing;\n}\n\n/* Back of the lid - visible when closed, metallic 3D */\n.closed-lid-cover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 8px;\n  overflow: hidden;\n  background: linear-gradient(\n    168deg,\n    #b0b0b0 0%,\n    #9a9a9a 20%,\n    #848484 45%,\n    #727272 70%,\n    #626262 100%\n  );\n  border-radius: 12px 12px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow:\n    inset 4px 4px 10px rgba(255, 255, 255, 0.4),\n    inset -3px -3px 8px rgba(0, 0, 0, 0.25),\n    inset 0 1px 0 rgba(255, 255, 255, 0.5);\n  border: 1px solid #b8b8b8;\n  border-top-color: #d0d0d0;\n  border-left-color: #c0c0c0;\n  border-right-color: #a0a0a0;\n  border-bottom: none;\n  transform: rotateX(180deg);\n  backface-visibility: hidden;\n  z-index: 200;\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n  pointer-events: auto !important;\n}\n\n.closed-lid-cover:active {\n  cursor: grabbing;\n}\n\n.closed-lid-logo {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  height: 48px;\n  width: auto;\n  object-fit: contain;\n  opacity: 0.7;\n}\n\n/* Lid edge (hinge area) - recessed 3D */\n.lid-edge {\n  height: 8px;\n  background: linear-gradient(180deg, #3a3a3a 0%, #2e2e2e 35%, #242424 70%, #1c1c1c 100%);\n  border-radius: 0 0 3px 3px;\n  margin-top: -1px;\n  box-shadow:\n    inset 0 3px 6px rgba(0, 0, 0, 0.65),\n    inset 0 1px 0 rgba(0, 0, 0, 0.4),\n    0 1px 0 rgba(255, 255, 255, 0.04);\n  border: 1px solid #2a2a2a;\n  border-top: none;\n}\n\n/* Silver/gray bezel - 3D chamfered look */\n.laptop-bezel {\n  background: linear-gradient(\n    168deg,\n    #585858 0%,\n    #484848 25%,\n    #3c3c3c 55%,\n    #323232 85%,\n    #282828 100%\n  );\n  border-radius: 12px 12px 0 0;\n  padding: 8px 8px 6px;\n  box-shadow:\n    0 -8px 20px rgba(0, 0, 0, 0.55),\n    inset 3px 3px 6px rgba(255, 255, 255, 0.15),\n    inset -2px -2px 4px rgba(0, 0, 0, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.12);\n  backface-visibility: hidden;\n  border: 1px solid #4a4a4a;\n  border-top-color: #6a6a6a;\n  border-left-color: #545454;\n  border-right-color: #3a3a3a;\n  border-bottom: none;\n}\n\n/* Back of lid (visible when closed) - silver back with Dell logo */\n.laptop-lid::after {\n  content: 'DELL';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 8px;\n  background: linear-gradient(180deg, #7a7a7a 0%, #6a6a6a 50%, #5a5a5a 100%);\n  border-radius: 12px 12px 0 0;\n  transform: rotateX(180deg);\n  transform-origin: bottom center;\n  backface-visibility: hidden;\n  z-index: 10;\n  border: 1px solid #888;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Arial Black', Arial, sans-serif;\n  font-size: 14px;\n  font-weight: 900;\n  color: #444;\n  letter-spacing: 4px;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);\n  opacity: 0;\n  transition: opacity 0.4s ease 0.4s;\n}\n\n.bezel-top {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px 0 4px;\n  position: relative;\n  min-height: 18px;\n  z-index: 30;\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n\n.bezel-top:active {\n  cursor: grabbing;\n}\n\n/* Sticker bomb - hand-placed feel, contained, no overlap */\n.closed-lid-sticker-img {\n  position: absolute;\n  height: auto;\n  object-fit: contain;\n  pointer-events: none;\n  border: none;\n  outline: none;\n  transform-origin: center center;\n}\n\n.closed-lid-sticker-1 {\n  top: 9%;\n  left: 11%;\n  width: 22%;\n  max-width: 72px;\n  z-index: 214;\n  transform: translate(1%, -2%) rotate(-27deg);\n}\n\n.closed-lid-sticker-2 {\n  top: 6%;\n  right: 13%;\n  width: 10%;\n  max-width: 34px;\n  z-index: 211;\n  transform: translate(-1%, 1%) rotate(4deg);\n}\n\n.closed-lid-sticker-3 {\n  bottom: 28%;\n  right: 19%;\n  width: 12%;\n  max-width: 40px;\n  z-index: 213;\n  transform: translate(-1%, 2%) rotate(-21deg);\n}\n\n.closed-lid-sticker-4 {\n  top: 23%;\n  right: 11%;\n  width: 15%;\n  max-width: 48px;\n  z-index: 216;\n  transform: translate(0, -1%) rotate(-16deg);\n}\n\n.closed-lid-sticker-5 {\n  top: 51%;\n  left: 31%;\n  width: 9%;\n  max-width: 30px;\n  z-index: 210;\n  transform: translate(-2%, 1%) rotate(24deg);\n}\n\n.closed-lid-sticker-6 {\n  top: 28%;\n  right: 32%;\n  width: 15%;\n  max-width: 50px;\n  z-index: 212;\n  transform: translate(-2%, -1%) rotate(-11deg);\n}\n\n.closed-lid-sticker-7 {\n  bottom: 11%;\n  left: 13%;\n  width: 14%;\n  max-width: 46px;\n  z-index: 215;\n  transform: translate(-1%, 0) rotate(-8deg);\n}\n\n.closed-lid-sticker-8 {\n  bottom: 7%;\n  right: 15%;\n  width: 13%;\n  max-width: 42px;\n  z-index: 211;\n  transform: translate(2%, calc(-1% - 12px)) rotate(19deg);\n}\n\n.webcam-dot {\n  width: 6px;\n  height: 6px;\n  background: radial-gradient(circle, #1a1a1a 40%, #0a0a0a 100%);\n  border-radius: 50%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  box-shadow:\n    inset 0 0 2px rgba(0, 0, 0, 0.8),\n    0 0 0 1.5px rgba(80, 80, 80, 0.5);\n}\n\n.dell-logo {\n  height: 24px;\n  width: auto;\n  object-fit: contain;\n  opacity: 0.85;\n}\n\n/* Inner screen - recessed glass 3D */\n.laptop-screen {\n  position: relative;\n  background: #080808;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 2px solid #1a1a1a;\n  border-top-color: #2a2a2a;\n  border-left-color: #242424;\n  border-right-color: #0e0e0e;\n  border-bottom-color: #0c0c0c;\n  transition: opacity 0.3s ease;\n  box-shadow:\n    inset 0 0 28px rgba(0, 0, 0, 0.95),\n    inset 0 3px 8px rgba(0, 0, 0, 0.6),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.dell-laptop.closed .laptop-screen {\n  opacity: 0;\n}\n\n.screen-header.win95-titlebar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height: 18px;\n  padding: 0 4px;\n  background: linear-gradient(90deg, #000080 0%, #1084d0 100%);\n  border: none;\n  border-bottom: 1px solid #000080;\n}\n\n.screen-header.win95-titlebar .win95-title {\n  color: #fff;\n  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;\n  font-size: 11px;\n  font-weight: bold;\n  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.3);\n}\n\n.win95-btn-minimize,\n.win95-btn-maximize,\n.win95-btn-close {\n  width: 14px;\n  height: 12px;\n  background: #c0c0c0;\n  border: 1px outset #dfdfdf;\n  font-size: 10px;\n  font-weight: bold;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  color: #000;\n  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;\n}\n\n.win95-btn-minimize:active,\n.win95-btn-maximize:active,\n.win95-btn-close:active {\n  border-style: inset;\n}\n\n@keyframes blink {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.3;\n  }\n}\n\n.video-wrapper {\n  position: relative;\n  overflow: hidden;\n  contain: layout style paint;\n  transform: translateZ(0);\n  pointer-events: none;\n}\n\n.video {\n  width: 100%;\n  display: block;\n  background: #000;\n  object-fit: cover;\n  transform: translateZ(0);\n  will-change: auto;\n  pointer-events: none;\n}\n\n.video-overlay {\n  display: none;\n}\n\n.video-scanline {\n  display: none;\n}\n\n.video-corner-logo {\n  position: absolute;\n  bottom: 6px;\n  right: 6px;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.video-corner-logo-img {\n  height: 24px;\n  width: auto;\n  max-width: 72px;\n  object-fit: contain;\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.5));\n}\n\n/* Windows balloon notification - click to open password dialog */\n.win-balloon-notification {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, calc(-50% - 60px));\n  z-index: 9999;\n  pointer-events: auto !important;\n  isolation: isolate;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  min-width: 200px;\n  max-width: 280px;\n  background: linear-gradient(180deg, #fff 0%, #f5f5f0 100%);\n  border: 1px solid #999;\n  border-radius: 4px;\n  box-shadow:\n    2px 2px 8px rgba(0, 0, 0, 0.25),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n  text-align: left;\n  user-select: none;\n  -webkit-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  animation: balloon-slide-in 0.3s ease-out;\n}\n\n.win-balloon-notification::before {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  right: 20px;\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #999;\n}\n\n.win-balloon-notification::after {\n  content: '';\n  position: absolute;\n  bottom: -6px;\n  right: 21px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 7px solid #f5f5f0;\n}\n\n.win-balloon-notification:hover {\n  background: linear-gradient(180deg, #fff 0%, #fffff0 100%);\n}\n\n.win-balloon-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.win-balloon-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.win-balloon-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: #003399;\n  margin-bottom: 2px;\n}\n\n.win-balloon-text {\n  font-size: 11px;\n  color: #333;\n  line-height: 1.3;\n}\n\n.win-balloon-close {\n  font-size: 14px;\n  color: #666;\n  font-weight: bold;\n  line-height: 1;\n  padding: 0 2px;\n  margin: -4px -4px 0 0;\n}\n\n.win-balloon-close:hover {\n  color: #c00;\n}\n\n@keyframes balloon-slide-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Windows XP Taskbar */\n.winxp-taskbar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 28px;\n  background: linear-gradient(\n    180deg,\n    #3168d5 0%,\n    #1842a3 3%,\n    #2b5cd7 5%,\n    #1d4fbf 90%,\n    #1941a3 100%\n  );\n  display: flex;\n  align-items: center;\n  padding: 0 2px;\n  z-index: 100;\n  border-top: 1px solid #0c3c8c;\n  font-family: 'Segoe UI', Tahoma, sans-serif;\n}\n\n.winxp-start-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 22px;\n  padding: 0 10px 0 6px;\n  background: linear-gradient(180deg, #3b9c3b 0%, #2d8c2d 50%, #1e7b1e 100%);\n  border: none;\n  border-radius: 0 8px 8px 0;\n  color: #fff;\n  font-weight: 700;\n  font-size: 11px;\n  font-style: italic;\n  cursor: pointer;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.3),\n    1px 1px 2px rgba(0, 0, 0, 0.3);\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n\n.winxp-start-btn:hover {\n  background: linear-gradient(180deg, #4bac4b 0%, #3d9c3d 50%, #2e8b2e 100%);\n}\n\n.winxp-start-btn:active {\n  background: linear-gradient(180deg, #1e7b1e 0%, #2d8c2d 50%, #3b9c3b 100%);\n}\n\n.winxp-start-logo {\n  font-size: 14px;\n  font-style: normal;\n}\n\n.winxp-start-logo-img {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n}\n\n.winxp-start-text {\n  letter-spacing: 0.5px;\n}\n\n.winxp-quicklaunch {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: 6px;\n  padding-left: 6px;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.winxp-ql-icon {\n  font-size: 12px;\n  padding: 2px 3px;\n  cursor: pointer;\n  border-radius: 2px;\n}\n\n.winxp-ql-icon:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.winxp-tasks {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: 6px;\n  padding-left: 6px;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  overflow: hidden;\n}\n\n.winxp-task {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 20px;\n  padding: 0 8px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 2px;\n  color: #fff;\n  font-size: 10px;\n  cursor: pointer;\n  max-width: 140px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.winxp-task.active {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.1) 100%);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.winxp-task-icon {\n  font-size: 11px;\n}\n\n.winxp-task-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.winxp-systray {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n  padding: 0 6px;\n  height: 100%;\n  background: linear-gradient(180deg, #0f8df5 0%, #0978d4 50%, #0560b8 100%);\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n}\n\n.winxp-tray-icon {\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.winxp-clock {\n  font-size: 10px;\n  color: #fff;\n  padding-left: 4px;\n  font-weight: 500;\n}\n\n/* Windows 95 Style Login Dialog - Compact */\n.win95-login-dialog {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -110%);\n  width: 220px;\n  max-width: 220px;\n  background: #c0c0c0;\n  border: 2px outset #dfdfdf;\n  box-shadow:\n    inset -1px -1px 0 #808080,\n    inset 1px 1px 0 #ffffff,\n    2px 2px 6px rgba(0, 0, 0, 0.4);\n  z-index: 10000;\n  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;\n  pointer-events: auto;\n}\n\n.win95-titlebar {\n  background: linear-gradient(90deg, #000080 0%, #1084d0 100%);\n  padding: 1px 2px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 14px;\n}\n\n.win95-titlebar.success {\n  background: linear-gradient(90deg, #008000 0%, #00a000 100%);\n}\n\n.win95-title {\n  color: #fff;\n  font-size: 9px;\n  font-weight: bold;\n  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.3);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.win95-titlebar-buttons {\n  display: flex;\n  gap: 1px;\n}\n\n.win95-content {\n  display: flex;\n  padding: 6px 6px 4px;\n  gap: 6px;\n}\n\n.win95-icon-section {\n  flex-shrink: 0;\n}\n\n.win95-key-icon {\n  font-size: 20px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.win95-form-section {\n  flex: 1;\n  min-width: 0;\n}\n\n.win95-message {\n  font-size: 9px;\n  color: #000;\n  margin: 0 0 4px 0;\n  line-height: 1.2;\n}\n\n.win95-field {\n  margin-bottom: 4px;\n}\n\n.win95-label {\n  font-size: 9px;\n  color: #000;\n  display: block;\n  margin-bottom: 1px;\n}\n\n.win95-input-display {\n  background: #fff;\n  border: 1px inset #808080;\n  padding: 2px 3px;\n  font-size: 9px;\n  min-height: 12px;\n  font-family: 'MS Sans Serif', Tahoma, sans-serif;\n}\n\n.win95-input-display.password {\n  letter-spacing: 1px;\n}\n\n.win95-cursor {\n  animation: win95-blink 1s step-end infinite;\n  color: #000;\n}\n\n@keyframes win95-blink {\n  0%,\n  50% {\n    opacity: 1;\n  }\n  51%,\n  100% {\n    opacity: 0;\n  }\n}\n\n.win95-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  padding: 2px 6px 6px;\n}\n\n.win95-btn {\n  min-width: 50px;\n  height: 16px;\n  background: #c0c0c0;\n  border: 1px outset #dfdfdf;\n  font-size: 9px;\n  font-family: 'MS Sans Serif', Tahoma, sans-serif;\n  cursor: pointer;\n  padding: 0 6px;\n}\n\n.win95-btn:active {\n  border-style: inset;\n}\n\n.win95-btn.active {\n  border: 1px solid #000;\n  outline: 1px dotted #000;\n  outline-offset: -3px;\n}\n\n.win95-btn.disabled {\n  color: #808080;\n  text-shadow: 1px 1px 0 #fff;\n  cursor: not-allowed;\n}\n\n.win95-status {\n  background: #c0c0c0;\n  border-top: 1px solid #808080;\n  padding: 2px 4px;\n  font-size: 8px;\n  color: #000;\n  text-align: center;\n}\n\n/* Success Dialog - Compact */\n.win95-success-dialog {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -110%);\n  width: 70%;\n  max-width: 140px;\n  background: #c0c0c0;\n  border: 2px outset #dfdfdf;\n  box-shadow:\n    inset -1px -1px 0 #808080,\n    inset 1px 1px 0 #ffffff,\n    2px 2px 6px rgba(0, 0, 0, 0.4);\n  z-index: 10000;\n  animation: win95-appear 0.2s ease-out;\n  pointer-events: auto;\n}\n\n@keyframes win95-appear {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n.win95-success-content {\n  padding: 10px;\n  text-align: center;\n}\n\n.win95-success-icon {\n  font-size: 24px;\n  margin-bottom: 6px;\n}\n\n.win95-success-text {\n  font-family: 'MS Sans Serif', Tahoma, sans-serif;\n  font-size: 9px;\n  font-weight: bold;\n  color: #008000;\n  margin: 0;\n}\n\n/* Dell Laptop Keyboard - 3D base, light from top-left */\n.laptop-keyboard {\n  background: linear-gradient(\n    168deg,\n    #989898 0%,\n    #848484 20%,\n    #707070 50%,\n    #5e5e5e 80%,\n    #4e4e4e 100%\n  );\n  border-radius: 0 0 10px 10px;\n  padding: 10px 12px 14px;\n  box-shadow:\n    0 10px 28px rgba(0, 0, 0, 0.55),\n    0 5px 12px rgba(0, 0, 0, 0.4),\n    inset 4px 4px 8px rgba(255, 255, 255, 0.22),\n    inset -3px -3px 6px rgba(0, 0, 0, 0.2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n  border: 1px solid #7a7a7a;\n  border-bottom-color: #454545;\n  border-left-color: #828282;\n  border-right-color: #6a6a6a;\n  border-top: none;\n  position: relative;\n  width: 100%;\n}\n\n/* Dell logo between mute and power buttons */\n.keyboard-dell-logo {\n  height: 24px;\n  width: auto;\n  flex-shrink: 0;\n  object-fit: contain;\n  opacity: 0.75;\n}\n\n.keyboard-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  padding: 0 6px;\n}\n\n.keyboard-top-left,\n.keyboard-top-right {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.keyboard-top-right {\n  justify-content: flex-end;\n}\n\n.keyboard-top-center {\n  flex: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 6px;\n}\n\n/* Speaker grilles - stretched like real laptop, recessed perforated look */\n.speaker-grille {\n  flex: 1;\n  min-width: 50px;\n  height: 12px;\n  background: repeating-linear-gradient(0deg, #1e1e1e 0px, #1e1e1e 1px, #363636 1px, #363636 2px);\n  border-radius: 2px;\n  border: 1px solid #181818;\n  box-shadow:\n    inset 0 3px 6px rgba(0, 0, 0, 0.75),\n    inset 0 1px 0 rgba(0, 0, 0, 0.5),\n    0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.mute-button {\n  width: 24px;\n  height: 18px;\n  flex-shrink: 0;\n  background: linear-gradient(175deg, #4a4a4a 0%, #3a3a3a 45%, #2a2a2a 100%);\n  border-radius: 3px;\n  border: 1px solid #4a4a4a;\n  border-top-color: #5a5a5a;\n  box-shadow:\n    0 1px 0 #1a1a1a,\n    inset 0 1px 0 rgba(255, 255, 255, 0.1),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.35);\n  font-size: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.mute-button:hover {\n  background: linear-gradient(180deg, #555 0%, #444 50%, #333 100%);\n}\n\n.mute-button:active {\n  transform: scale(0.95);\n}\n\n.mute-button .mute-button-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.mute-button.muted .mute-button-icon {\n  color: #cc2222;\n  animation: mute-icon-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes mute-icon-pulse {\n  0%,\n  100% {\n    filter: drop-shadow(0 0 3px #cc2222) drop-shadow(0 0 8px rgba(204, 34, 34, 0.8));\n    opacity: 1;\n  }\n  50% {\n    filter: drop-shadow(0 0 6px #cc2222) drop-shadow(0 0 14px rgba(204, 34, 34, 0.9));\n    opacity: 0.9;\n  }\n}\n\n.mute-button.muted {\n  box-shadow:\n    inset 0 1px 2px rgba(0, 0, 0, 0.4),\n    0 1px 0 #1a1a1a;\n}\n\n.power-button {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  background: linear-gradient(175deg, #5a5a5a 0%, #484848 45%, #363636 100%);\n  border-radius: 50%;\n  border: 1px solid #4a4a4a;\n  border-top-color: #666;\n  box-shadow:\n    0 1px 0 #1e1e1e,\n    inset 0 1px 0 rgba(255, 255, 255, 0.12),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.4);\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.power-button:hover {\n  background: linear-gradient(180deg, #666 0%, #555 50%, #444 100%);\n  transform: scale(1.05);\n}\n\n.power-button:active {\n  transform: scale(0.95);\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.6);\n}\n\n.power-icon {\n  font-size: 10px;\n  color: #888;\n  line-height: 1;\n}\n\n.power-button.on .power-icon {\n  color: #00ff00;\n  text-shadow:\n    0 0 6px #00ff00,\n    0 0 12px rgba(0, 255, 0, 0.6);\n}\n\n.power-button.off .power-icon {\n  color: #666;\n}\n\n.power-button.booting .power-icon {\n  color: #ffaa00;\n}\n\n.power-button.booting {\n  box-shadow:\n    inset 0 1px 2px rgba(0, 0, 0, 0.5),\n    0 1px 0 #1e1e1e;\n}\n\n.power-button.booting .power-icon {\n  animation: power-icon-pulse-yellow 0.5s ease-in-out infinite;\n}\n\n@keyframes power-icon-pulse-yellow {\n  0%,\n  100% {\n    text-shadow:\n      0 0 4px #ffaa00,\n      0 0 8px rgba(255, 170, 0, 0.6);\n  }\n  50% {\n    text-shadow:\n      0 0 8px #ffaa00,\n      0 0 16px rgba(255, 170, 0, 0.9);\n  }\n}\n\n.power-button.shutting-down {\n  box-shadow:\n    inset 0 1px 2px rgba(0, 0, 0, 0.5),\n    0 1px 0 #1e1e1e;\n}\n\n.power-button.shutting-down .power-icon {\n  animation: power-icon-pulse-orange 0.3s ease-in-out infinite;\n}\n\n@keyframes power-icon-pulse-orange {\n  0%,\n  100% {\n    text-shadow:\n      0 0 4px #ff6600,\n      0 0 8px rgba(255, 102, 0, 0.6);\n  }\n  50% {\n    text-shadow:\n      0 0 8px #ff6600,\n      0 0 16px rgba(255, 102, 0, 0.9);\n  }\n}\n\n/* Power LED indicator - on the power button */\n.power-button::after {\n  content: '';\n  position: absolute;\n  bottom: 3px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: #00ff00;\n  box-shadow: 0 0 3px rgba(0, 255, 0, 0.8);\n  transition: all 0.3s ease;\n}\n\n.power-button.off::after {\n  background: #444;\n  box-shadow: none;\n}\n\n/* Lid open + powered off (not booting): power icon pulses red */\n.dell-laptop.open .power-button.off:not(.booting):not(.shutting-down) {\n  box-shadow:\n    inset 0 1px 2px rgba(0, 0, 0, 0.5),\n    0 1px 0 #1e1e1e;\n}\n\n.dell-laptop.open .power-button.off:not(.booting):not(.shutting-down) .power-icon {\n  color: #cc2222;\n  animation: power-icon-pulse-red 1.2s ease-in-out infinite;\n}\n\n.dell-laptop.open .power-button.off:not(.booting):not(.shutting-down)::after {\n  opacity: 0;\n}\n\n@keyframes power-icon-pulse-red {\n  0%,\n  100% {\n    text-shadow:\n      0 0 4px #cc2222,\n      0 0 8px rgba(204, 34, 34, 0.6);\n  }\n  50% {\n    text-shadow:\n      0 0 8px #cc2222,\n      0 0 16px rgba(204, 34, 34, 0.9);\n  }\n}\n\n.power-button.booting::after,\n.power-button.shutting-down::after {\n  opacity: 0;\n}\n\n.dell-laptop.closed .power-button::after {\n  background: #555;\n  box-shadow: none;\n}\n\n/* Boot Screen */\n.boot-screen {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.boot-screen.off {\n  background: #0a0a0a;\n}\n\n.boot-screen.booting {\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding: 8px;\n}\n\n.power-off-text {\n  color: #e0e0e0;\n  font-family: 'Courier New', monospace;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  text-shadow: 0 0 8px rgba(255, 255, 255, 0.3);\n  letter-spacing: 0.5px;\n}\n\n@keyframes pulse-dim {\n  0%,\n  100% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n.boot-terminal {\n  font-family: 'Courier New', monospace;\n  font-size: 9px;\n  color: #00ff00;\n  line-height: 1.4;\n  text-shadow: 0 0 2px #00ff00;\n  width: 100%;\n  overflow: hidden;\n}\n\n.boot-line {\n  white-space: nowrap;\n  overflow: hidden;\n  animation: type-in 0.1s ease-out;\n}\n\n@keyframes type-in {\n  from {\n    opacity: 0;\n    transform: translateX(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.boot-cursor {\n  display: inline-block;\n  animation: cursor-blink 0.5s step-end infinite;\n}\n\n@keyframes cursor-blink {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n/* Windows 95 Shutdown Screen */\n.shutdown-screen {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #008080;\n  z-index: 55;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: shutdown-fade-in 0.5s ease-out;\n}\n\n@keyframes shutdown-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.shutdown-content {\n  text-align: center;\n  animation: shutdown-appear 0.8s ease-out 0.3s both;\n}\n\n@keyframes shutdown-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.shutdown-logo {\n  margin-bottom: 16px;\n}\n\n.win95-logo-img {\n  width: 80px;\n  height: auto;\n  animation: flag-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes flag-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n/* Screen off state - pure black */\n.laptop-screen.screen-off {\n  background: #000 !important;\n}\n\n.shutdown-text {\n  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;\n  font-size: 18px;\n  color: #ffcc00;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n  margin-bottom: 4px;\n}\n\n.shutdown-subtext {\n  font-family: 'MS Sans Serif', 'Segoe UI', Tahoma, sans-serif;\n  font-size: 18px;\n  color: #ffcc00;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.power-button.shutting-down .power-icon {\n  color: #ff6600;\n  animation: power-icon-pulse-orange 0.3s ease-in-out infinite;\n}\n\n/* Typing line style */\n.boot-line.typing {\n  color: #00ff00;\n}\n\n/* Windows 95 Startup Video */\n.startup-video-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  z-index: 52;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.startup-video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: #000;\n}\n\n.keyboard-keys {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 8px;\n  background: linear-gradient(168deg, #3e3e3e 0%, #323232 40%, #282828 75%, #1e1e1e 100%);\n  padding: 8px 10px;\n  border-radius: 6px;\n  box-shadow:\n    inset 4px 4px 10px rgba(0, 0, 0, 0.6),\n    inset -2px -2px 4px rgba(0, 0, 0, 0.25),\n    inset 0 1px 0 rgba(255, 255, 255, 0.05);\n  border: 1px solid #2e2e2e;\n  border-top-color: #3a3a3a;\n  border-left-color: #323232;\n  transition: box-shadow 0.3s ease;\n}\n\n.keyboard-keys.active {\n  box-shadow:\n    inset 0 2px 4px rgba(0, 0, 0, 0.4),\n    0 0 15px rgba(0, 255, 0, 0.2);\n}\n\n.key-row {\n  display: flex;\n  gap: 3px;\n  justify-content: center;\n  align-items: center;\n}\n\n.key-row.bottom {\n  margin-top: 2px;\n}\n\n/* Dell-style keys: fuller, easier to read */\n.key {\n  width: 21px;\n  height: 15px;\n  background: linear-gradient(175deg, #4a4a4a 0%, #3a3a3a 35%, #2e2e2e 70%, #242424 100%);\n  border-radius: 4px;\n  box-shadow:\n    0 2px 0 #161616,\n    0 1px 0 rgba(0, 0, 0, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.35);\n  border: 1px solid #2a2a2a;\n  border-top-color: #3a3a3a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: all 0.1s ease;\n}\n\n.key-label {\n  font-family: 'Segoe UI', system-ui, sans-serif;\n  font-size: 7px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.65);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  pointer-events: none;\n}\n\n.key.clickable {\n  cursor: pointer;\n}\n\n.key.clickable:hover {\n  background: linear-gradient(175deg, #545454 0%, #444444 50%, #363636 100%);\n  box-shadow:\n    0 2px 0 #161616,\n    inset 0 1px 0 rgba(255, 255, 255, 0.14),\n    0 0 10px rgba(0, 255, 0, 0.25);\n}\n\n.key.clickable:hover .key-label {\n  color: rgba(0, 255, 0, 0.8);\n}\n\n.key.pressed {\n  background: linear-gradient(180deg, #282828 0%, #1a1a1a 100%);\n  box-shadow:\n    0 1px 0 #0e0e0e,\n    inset 0 2px 5px rgba(0, 0, 0, 0.7),\n    0 0 12px rgba(0, 255, 0, 0.4);\n  transform: translateY(1px);\n}\n\n.key.pressed .key-label {\n  color: #0f0;\n  text-shadow: 0 0 4px #0f0;\n}\n\n.key.backspace {\n  width: 34px;\n}\n\n.key.enter {\n  width: 34px;\n}\n\n.key.enter .key-label {\n  font-size: 6px;\n  text-transform: none;\n  letter-spacing: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n}\n\n.key.enter .key-enter-icon {\n  font-size: 9px;\n  line-height: 1;\n  opacity: 0.9;\n}\n\n.key.shift {\n  width: 34px;\n  font-size: 6px;\n}\n\n.key.shift.caps-on {\n  background: var(--accent, #2563eb);\n  color: #fff;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.key.spacebar {\n  width: 110px;\n}\n\n.key.ctrl,\n.key.fn,\n.key.win,\n.key.alt {\n  width: 28px;\n}\n\n.arrow-keys {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  margin-left: 6px;\n}\n\n.key.arrow {\n  width: 15px;\n  height: 9px;\n}\n\n.key.arrow.up {\n  margin: 0 auto;\n}\n\n.arrow-bottom {\n  display: flex;\n  gap: 1px;\n}\n\n/* Trackpad area - Dell-style: one recessed unit, touchpad + buttons blended */\n.trackpad-area {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n  margin-top: 6px;\n}\n\n.trackpad-buttons {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  order: 2;\n  width: 110px;\n  height: 12px;\n  border: 1px solid #4a4a4a;\n  border-top: none;\n  border-radius: 0 0 6px 6px;\n  overflow: hidden;\n  box-shadow:\n    inset 0 3px 6px rgba(0, 0, 0, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.trackpad-btn {\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  background: linear-gradient(180deg, #5a5a5a 0%, #505050 50%, #464646 100%);\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.trackpad-btn + .trackpad-btn {\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n}\n\n/* Red trackpoint nub - hidden since buttons are at bottom now */\n.trackpoint {\n  display: none;\n}\n\n/* Laptop stickers - like real business laptops */\n.laptop-stickers {\n  position: absolute;\n  bottom: 9px;\n  left: 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  z-index: 2;\n}\n\n.sticker {\n  padding: 0;\n  border-radius: 0;\n  font-size: 6px;\n  font-weight: bold;\n  box-shadow: none;\n  line-height: 0;\n}\n\n.sticker-intel {\n  background: transparent;\n  box-shadow: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.sticker-intel-img,\n.sticker-win-img {\n  height: 22px;\n  width: auto;\n  display: block;\n  object-fit: contain;\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.25)) drop-shadow(0 0 0 1px rgba(0, 0, 0, 0.06));\n  opacity: 0.92;\n}\n\n.sticker-win-img {\n  height: 28px;\n}\n\n.sticker-win {\n  background: transparent;\n  box-shadow: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n/* Touchpad - recessed 3D */\n.touchpad {\n  width: 110px;\n  height: 55px;\n  background: linear-gradient(168deg, #606060 0%, #545454 40%, #4a4a4a 80%, #424242 100%);\n  border: 1px solid #4a4a4a;\n  border-bottom: none;\n  border-radius: 6px 6px 0 0;\n  box-shadow:\n    inset 3px 3px 8px rgba(0, 0, 0, 0.45),\n    inset -1px -1px 2px rgba(0, 0, 0, 0.2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  order: 1;\n}\n\n/* Hide old monitor controls */\n.monitor-controls {\n  display: none;\n}\n\n.control-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  contain: layout style paint;\n}\n\n.control-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: #fff;\n  transform: scale(1.1);\n}\n\n.control-btn:active {\n  transform: scale(0.95);\n}\n\n.control-btn svg {\n  width: 18px;\n  height: 18px;\n  fill: #fff;\n}\n\n.play-btn {\n  width: 42px;\n  height: 42px;\n  border-color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n  border-width: 2px;\n}\n\n.play-btn svg {\n  width: 20px;\n  height: 20px;\n  fill: #fff;\n}\n\n.scanlines {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 5;\n  background: repeating-linear-gradient(\n    0deg,\n    rgba(0, 0, 0, 0.08) 0px,\n    rgba(0, 0, 0, 0.08) 1px,\n    transparent 1px,\n    transparent 2px\n  );\n}\n\n.formula {\n  position: absolute;\n  font-family: 'Bebas Neue', monospace;\n  font-size: 10px;\n  color: var(--bb-black);\n  letter-spacing: 1px;\n  font-weight: bold;\n  opacity: 0.4;\n  animation: formula-pulse 8s ease-in-out infinite;\n  will-change: opacity;\n  background: var(--bb-yellow);\n  padding: 2px 4px;\n  border: 1px solid var(--bb-black);\n  contain: layout style paint;\n  transform: translateZ(0);\n}\n.formula:nth-child(1) {\n  top: 6%;\n  left: 12px;\n}\n.formula:nth-child(2) {\n  top: 12%;\n  right: 12px;\n  animation-delay: 2s;\n}\n.formula:nth-child(3) {\n  bottom: 14%;\n  left: 12px;\n  animation-delay: 4s;\n}\n.formula:nth-child(4) {\n  bottom: 8%;\n  right: 12px;\n  animation-delay: 6s;\n}\n\n.biohazard {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  opacity: 0.25;\n  animation: bio-pulse 5s ease-in-out infinite;\n  will-change: opacity;\n  fill: var(--bb-black);\n}\n.biohazard.left {\n  top: 50%;\n  left: 8px;\n  transform: translateY(-50%);\n}\n.biohazard.right {\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  animation-delay: 2.5s;\n}\n\n/* Crystal Slider Styles - Compact */\n.crystal-slider-container {\n  position: relative;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-top: 20px;\n  animation: fade-in 0.8s ease-out 0.5s forwards;\n  opacity: 0;\n  width: 85%;\n  max-width: 280px;\n}\n\n.crystal-slider-track {\n  position: relative;\n  width: 100%;\n  height: 48px;\n  background: transparent;\n  border-radius: 24px;\n  overflow: visible;\n  user-select: none;\n  -webkit-user-select: none;\n  border: none;\n  box-shadow: none;\n}\n\n.crystal-slider-track.locked {\n  cursor: text;\n  background: transparent;\n  border: none;\n}\n\n.crystal-slider-track.unlocked {\n  cursor: default;\n}\n\n.crystal-slider-track.dragging {\n  /* no background change */\n}\n\n.crystal-slider-track.success {\n  /* no background change */\n}\n\n.slider-progress-fill {\n  display: none;\n}\n\n/* Slider text display */\n.slider-text-display {\n  position: absolute;\n  left: 110px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: calc(100% - 120px);\n  font-family: 'Bebas Neue', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  color: #ffffff;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  text-align: left;\n  z-index: 5;\n  padding: 0;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.crystal-slider-track.unlocked .slider-text-display {\n  color: #0f0;\n  text-shadow: 0 0 8px rgba(0, 255, 0, 0.5);\n  animation: text-glow 1.5s ease-in-out infinite;\n}\n\n@keyframes text-glow {\n  0%,\n  100% {\n    text-shadow: 0 0 8px rgba(0, 255, 0, 0.5);\n  }\n  50% {\n    text-shadow:\n      0 0 15px rgba(0, 255, 0, 0.8),\n      0 0 25px rgba(0, 255, 0, 0.4);\n  }\n}\n\n.crystal-slider-track.success .slider-text-display {\n  color: var(--green-dark);\n}\n\n.crystal-thumb {\n  position: absolute;\n  top: 50%;\n  margin-top: -32px;\n  width: 100px;\n  height: 64px;\n  cursor: grab;\n  z-index: 10;\n  transition:\n    left 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    filter 0.2s ease,\n    opacity 0.2s ease,\n    transform 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  box-sizing: border-box;\n}\n\n.crystal-thumb.dragging {\n  transition: none;\n}\n\n.crystal-thumb:not(.dragging) {\n  transition:\n    left 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),\n    filter 0.2s ease,\n    opacity 0.2s ease,\n    transform 0.15s ease;\n}\n\n.crystal-thumb.disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n  filter: grayscale(0.5);\n}\n\n.crystal-thumb:active,\n.crystal-thumb.dragging {\n  cursor: grabbing;\n}\n\n.crystal-thumb.success {\n  animation: crystal-success 0.6s ease-out;\n}\n\n@keyframes crystal-success {\n  0% {\n    transform: scale(1);\n  }\n  30% {\n    transform: scale(1.3);\n  }\n  60% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.crystal-image {\n  width: auto;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  object-position: center center;\n  filter: drop-shadow(0 4px 8px rgba(125, 211, 252, 0.5));\n  transition:\n    filter 0.2s ease,\n    transform 0.2s ease;\n  pointer-events: none;\n  display: block;\n  margin: 0 auto;\n}\n\n.crystal-thumb:hover .crystal-image,\n.crystal-thumb.dragging .crystal-image {\n  filter: drop-shadow(0 6px 15px rgba(125, 211, 252, 0.7)) brightness(1.1);\n  transform: scale(1.05);\n}\n\n.crystal-thumb.success .crystal-image {\n  filter: drop-shadow(0 8px 20px rgba(30, 123, 52, 0.6)) brightness(1.2);\n}\n\n.crystal-image.money-image {\n  width: 180%;\n  height: auto;\n  max-height: none;\n  filter: drop-shadow(0 4px 12px rgba(34, 197, 94, 0.6));\n}\n\n.crystal-glow {\n  position: absolute;\n  width: 70px;\n  height: 70px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: radial-gradient(\n    ellipse at center,\n    rgba(125, 211, 252, 0.4) 0%,\n    rgba(125, 211, 252, 0.1) 40%,\n    transparent 70%\n  );\n  border-radius: 50%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  animation: glow-pulse 2s ease-in-out infinite;\n}\n\n.crystal-thumb:hover .crystal-glow,\n.crystal-thumb.dragging .crystal-glow {\n  opacity: 1;\n}\n\n.crystal-thumb.success .crystal-glow {\n  background: radial-gradient(\n    ellipse at center,\n    rgba(30, 123, 52, 0.5) 0%,\n    rgba(30, 123, 52, 0.2) 40%,\n    transparent 70%\n  );\n  opacity: 1;\n}\n\n@keyframes glow-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 1;\n  }\n}\n\n.slider-hint {\n  font-family: 'Bebas Neue', sans-serif;\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.8);\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin: 0;\n  margin-top: 8px;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);\n}\n\n@keyframes hint-pulse {\n  0%,\n  100% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 0.8;\n  }\n}\n\n.landing-container.unlocking {\n  animation: unlock 1.2s ease-in-out forwards;\n}\n\n@keyframes unlock {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.02);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.1);\n  }\n}\n\n.vignette {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 2;\n  background: radial-gradient(ellipse at center, transparent 30%, var(--black-rgba-70) 100%);\n}\n\n@keyframes smoke-rise {\n  0% {\n    transform: translateY(100vh) scale(0.5);\n    opacity: 0;\n  }\n  10% {\n    opacity: 0.5;\n  }\n  90% {\n    opacity: 0.15;\n  }\n  100% {\n    transform: translateY(-100vh) scale(1.8);\n    opacity: 0;\n  }\n}\n@keyframes toxic-drift {\n  0%,\n  100% {\n    transform: translateY(80vh) scale(0.8);\n    opacity: 0;\n  }\n  20% {\n    opacity: 0.4;\n  }\n  80% {\n    opacity: 0.15;\n  }\n}\n@keyframes sparkle {\n  0%,\n  100% {\n    opacity: 0.2;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.3);\n  }\n}\n@keyframes stripe-move {\n  to {\n    background-position: 400px 0;\n    transform: translateZ(0);\n  }\n}\n@keyframes fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n@keyframes video-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes border-shift {\n  0%,\n  100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n@keyframes formula-pulse {\n  0%,\n  100% {\n    opacity: 0.25;\n  }\n  50% {\n    opacity: 0.45;\n  }\n}\n@keyframes bio-pulse {\n  0%,\n  100% {\n    opacity: 0.05;\n  }\n  50% {\n    opacity: 0.12;\n  }\n}\n@keyframes tagline-appear {\n  to {\n    opacity: 0.5;\n  }\n}\n\n/* Loading Modal Styles - Yellow to White Transition */\n.loading-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: var(--bb-yellow);\n  animation: bg-yellow-to-white 2.5s ease-in-out forwards;\n}\n\n@keyframes bg-yellow-to-white {\n  0% {\n    background: var(--bb-yellow);\n  }\n  40% {\n    background: var(--bb-yellow);\n  }\n  100% {\n    background: #ffffff;\n  }\n}\n\n.loading-modal-overlay.phase-1 {\n  opacity: 1;\n}\n\n/* Top Text */\n.loading-top-text {\n  position: absolute;\n  top: 120px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: all 0.8s ease-out;\n}\n\n.loading-top-text.visible {\n  opacity: 1;\n}\n\n.loading-top-text span {\n  font-family: 'Bebas Neue', sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  color: var(--bb-black);\n  letter-spacing: 6px;\n  text-transform: uppercase;\n}\n\n/* Center Logo */\n.loading-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transform: scale(0.3);\n  transition: all 1.2s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.loading-center.visible {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.heisenberg-logo {\n  width: 180px;\n  height: auto;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));\n  animation: logo-settle 1.5s ease-out forwards;\n}\n\n@keyframes logo-settle {\n  0% {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n  60% {\n    transform: scale(1.05);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Bottom Text */\n.loading-bottom-text {\n  position: absolute;\n  bottom: 140px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: all 0.8s ease-out;\n}\n\n.loading-bottom-text.visible {\n  opacity: 1;\n}\n\n.loading-bottom-text span {\n  font-family: 'Bebas Neue', sans-serif;\n  font-size: 28px;\n  font-weight: bold;\n  color: var(--bb-black);\n  letter-spacing: 8px;\n  text-transform: uppercase;\n}\n\n/* Progress Bar */\n.loading-progress-bar {\n  position: absolute;\n  bottom: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 200px;\n  height: 3px;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 2px;\n  overflow: hidden;\n  opacity: 0;\n  transition: opacity 0.5s ease-out;\n}\n\n.loading-progress-bar.visible {\n  opacity: 1;\n}\n\n.progress-fill {\n  height: 100%;\n  width: 0%;\n  background: var(--bb-black);\n  border-radius: 2px;\n  animation: progress-load 1.2s ease-out forwards;\n}\n\n@keyframes progress-load {\n  0% {\n    width: 0%;\n  }\n  100% {\n    width: 100%;\n  }\n}\n\n/* Error Modal - Red Background */\n.error-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #8b0000;\n  animation: error-flash 0.3s ease-out;\n}\n\n@keyframes error-flash {\n  0% {\n    opacity: 0;\n    background: #ff0000;\n  }\n  50% {\n    background: #ff0000;\n  }\n  100% {\n    opacity: 1;\n    background: #8b0000;\n  }\n}\n\n.error-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  animation: error-shake 0.5s ease-out;\n}\n\n@keyframes error-shake {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  20% {\n    transform: translateX(-20px);\n  }\n  40% {\n    transform: translateX(20px);\n  }\n  60% {\n    transform: translateX(-15px);\n  }\n  80% {\n    transform: translateX(15px);\n  }\n}\n\n.error-heisenberg {\n  width: 150px;\n  height: auto;\n  filter: brightness(0) invert(1) drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));\n  animation: error-pulse 1s ease-in-out infinite;\n}\n\n@keyframes error-pulse {\n  0%,\n  100% {\n    filter: brightness(0) invert(1) drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));\n  }\n  50% {\n    filter: brightness(0) invert(1) drop-shadow(0 0 40px rgba(255, 255, 255, 0.8));\n  }\n}\n\n.error-text {\n  font-family: 'Bebas Neue', sans-serif;\n  font-size: 36px;\n  font-weight: bold;\n  color: #fff;\n  letter-spacing: 8px;\n  text-transform: uppercase;\n  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);\n}\n\n.error-subtext {\n  font-family: 'Bebas Neue', sans-serif;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  letter-spacing: 3px;\n  text-transform: uppercase;\n}\n\n/* Mobile responsive - all phone sizes */\n@media (max-width: 430px) {\n  .landing-container {\n    max-width: 100vw;\n  }\n  .periodic-elements {\n    grid-template-columns: repeat(2, minmax(120px, 1fr));\n  }\n  .element-tile {\n    height: 76px;\n    padding: 10px 8px 8px;\n  }\n  .element-symbol {\n    font-size: 28px;\n  }\n  .element-name {\n    font-size: 8px;\n    letter-spacing: 1.5px;\n  }\n  .smoke {\n    width: 120px;\n    height: 120px;\n    filter: blur(25px);\n  }\n  .toxic-smoke {\n    width: 150px;\n    height: 150px;\n    filter: blur(35px);\n  }\n  .formula {\n    font-size: 9px;\n  }\n  .biohazard {\n    width: 30px;\n    height: 30px;\n  }\n  .heisenberg-image {\n    width: 150px;\n  }\n  .loading-letter {\n    font-size: 32px;\n  }\n  .loading-modal {\n    padding: 30px 20px;\n  }\n  .lab-monitor {\n    width: 94%;\n    max-width: 100%;\n  }\n  .touchpad {\n    width: 80px;\n    height: 40px;\n  }\n  .key.spacebar {\n    width: 60px;\n  }\n  .crystal-slider-container {\n    width: 88%;\n    max-width: 100%;\n    margin-top: 16px;\n  }\n  .crystal-slider-track {\n    height: 44px;\n  }\n  .crystal-thumb {\n    width: 120px;\n    height: 85px;\n    margin-top: -42px;\n  }\n  .slider-text-display {\n    left: 130px;\n    width: calc(100% - 140px);\n    font-size: 14px;\n    letter-spacing: 2px;\n  }\n\n  .key-label {\n    font-size: 5px;\n  }\n\n  .video-login-popup {\n    width: 85%;\n  }\n\n  .login-password-display {\n    font-size: 14px;\n    letter-spacing: 2px;\n  }\n  .hazmat-stripe {\n    height: 40px;\n  }\n}\n\n/* Small phones (iPhone SE, Galaxy S8, etc.) */\n@media (max-width: 375px) {\n  .lab-monitor {\n    width: 96%;\n  }\n  .crystal-slider-container {\n    width: 90%;\n    margin-top: 14px;\n  }\n  .crystal-slider-track {\n    height: 42px;\n  }\n  .crystal-thumb {\n    width: 100px;\n    height: 75px;\n    margin-top: -37px;\n  }\n  .slider-text-display {\n    left: 110px;\n    width: calc(100% - 120px);\n    font-size: 12px;\n    letter-spacing: 1px;\n  }\n\n  .key {\n    width: 16px;\n    height: 12px;\n  }\n\n  .key-label {\n    font-size: 4px;\n  }\n\n  .key.spacebar {\n    width: 70px;\n  }\n\n  .key.backspace,\n  .key.enter,\n  .key.shift {\n    width: 24px;\n  }\n  .monitor-header {\n    padding: 6px 10px;\n  }\n  .monitor-dots .dot {\n    width: 8px;\n    height: 8px;\n  }\n  .control-btn {\n    width: 32px;\n    height: 32px;\n  }\n  .play-btn {\n    width: 38px;\n    height: 38px;\n  }\n  .biohazard {\n    width: 24px;\n    height: 24px;\n  }\n  .formula {\n    font-size: 8px;\n  }\n  .hazmat-stripe {\n    height: 35px;\n  }\n  .loading-top-text span {\n    font-size: 18px;\n    letter-spacing: 4px;\n  }\n  .loading-bottom-text span {\n    font-size: 22px;\n    letter-spacing: 5px;\n  }\n  .heisenberg-logo {\n    width: 140px;\n  }\n  .error-text {\n    font-size: 28px;\n    letter-spacing: 5px;\n  }\n  .error-subtext {\n    font-size: 12px;\n    letter-spacing: 2px;\n    text-align: center;\n    padding: 0 20px;\n  }\n}\n\n/* Extra small phones */\n@media (max-width: 320px) {\n  .crystal-slider-container {\n    width: 92%;\n    margin-top: 12px;\n  }\n  .crystal-slider-track {\n    height: 40px;\n  }\n  .crystal-thumb {\n    width: 90px;\n    height: 65px;\n    margin-top: -32px;\n  }\n  .slider-text-display {\n    left: 95px;\n    width: calc(100% - 105px);\n    font-size: 11px;\n  }\n\n  .key {\n    width: 14px;\n    height: 10px;\n  }\n\n  .key.spacebar {\n    width: 55px;\n  }\n  .lab-monitor {\n    width: 98%;\n  }\n}\n\n/* Tall phones (iPhone X/11/12/13/14 Pro Max, etc.) */\n@media (min-height: 800px) {\n  .crystal-slider-container {\n    margin-top: 24px;\n  }\n}\n\n/* Short phones */\n@media (max-height: 650px) {\n  .lab-monitor {\n    width: 85%;\n  }\n  .crystal-slider-container {\n    margin-top: 16px;\n  }\n  .hazmat-stripe {\n    height: 30px;\n  }\n  .title-container {\n    margin-bottom: 12px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
